import React, { Component } from 'react';
import redirectURL from '../redirectURL';
import Modal from 'react-responsive-modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import NegotiationCutoffTimer from './countdownfornegotiation';
import { getHyphenDDMMYYYYHHMM, getHyphenDDMMYYYYHHMMSS, getHyphenYYYYMMDDHHMM, getHyphenDDMMYYYY } from '../common/utils';
import { onNewBid, emitDataReceived } from '../socketManager';

import moment from 'moment';
const userType = localStorage.getItem("user_type");
class BidDetailsScreen extends Component {
  constructor(props) {
    super(props);
    const { state } = this.props.location
    this.state = {
      indent_id: state.indent_id,
      selectedIndentData: {},
      selectedVendorQuotes: [],
      negotiations: [],
      selectedindentdata1: {},
      negotiationsLogs: [],
      rfqform: {},
      inputTextValues: {},
      proposedValues: {},
      proposedDays: {},
      vendorValues: {},
      vendorDays: {},
      indent_for_approve1: [],
      selectedindent: {},
      dataforadminbifur: [],
      showsweetalert: false,
      basicType: '',
      basicTitle: '',
      show1: false,
      basicType1: '',
      basicTitle1: '',
      hoveredIconId: null,
      overlay: 'show-n',
      loadshow: 'show-n',
      negotiationEnded: false,
      leastValue: 0,
      avgValue: 0

    };
  }
  componentDidMount() {
    // Push current state so popstate will trigger
    // window.history.pushState({}, "", window.location.href);

    // window.addEventListener("popstate", this.handleBackButton);
    // this.fetchData()
    this.getRouteAvgValueperIndent()
    this.getInitialDataForBidDetailsScreen()

    onNewBid((data) => {
      this.getRouteAvgValueperIndent()
      this.getInitialDataForBidDetailsScreen()
    })

    // re-render every second so the negotiation cutoff is re-evaluated live
    // (Accept buttons must disable the moment the window closes)
    this.negotiationTicker = setInterval(() => {
      this.setState({ negotiationTick: Date.now() })
    }, 1000)
  }

  componentWillUnmount() {
    if (this.negotiationTicker) {
      clearInterval(this.negotiationTicker)
      this.negotiationTicker = null
    }
  }


  getInitialDataForBidDetailsScreen = async () => {
    const parmas = {
      indent_id: this.state.indent_id,
    }

    await redirectURL.post('/consignments/getInitialDataForBidDetailsScreen', parmas).then(response => {
      const indentData = response.data.indentDetails
      indentData.status = this.getStatusFromIndent(indentData)

      const proposedValues = response.data.negotiations.reduce((acc, q) => {
        acc[q.vendor_email_id] = q.proposed_value || '';
        return acc;
      }, {});

      console.log(proposedValues, "proposedValues")

      const proposedDays = response.data.negotiations.reduce((acc, q) => {
        acc[q.vendor_email_id] = q.proposed_quantity || '';
        return acc;
      }, {});

      const vendorValues = response.data.negotiations.reduce((acc, q) => {
        acc[q.vendor_email_id] = q.vendor_value || '';
        return acc;
      }, {});

      const vendorDays = response.data.negotiations.reduce((acc, q) => {
        acc[q.vendor_email_id] = q.vendor_quantity || '';
        return acc;
      }, {});

      const month_year = moment(indentData.bid_start_date).subtract(1, "month").format("MMM-YY");
      console.log("month_year", month_year)
      redirectURL.post("/consignments/fetchVendorsSOB", { month_year , source  : indentData.source }).then((response) => {
        const data = response.data && response.data[0] ? response.data[0] : {};
        this.setState({
          vendors_sob: data.vendors || []
        })
      });

      this.setState({
        selectedIndentData: indentData || {},
        selectedVendorQuotes: response.data.vendorQuotes || [],
        negotiations: response.data.negotiations || [],
        selectedindentdata1: indentData || {},
        negotiationsLogs: response.data.negotiationslogs || [],
        rfqform: {},
        proposedValues: proposedValues,
        proposedDays: proposedDays,
        vendorValues: vendorValues,
        vendorDays: vendorDays,
        dataforadminbifur: response.data.adminbifurData || {},
        // lr_no_data : response.data.lr_no_data || []
      })
    })
  }




  getRouteAvgValueperIndent = async () => {
    await redirectURL.post('/consignments/getRouteAvgValueperIndent', { indent_id: this.state.indent_id }).then(response => {
      this.setState({
        leastValue: response.data.leastValue || 0,
        avgValue: (response.data.avgValue).toFixed(2) || 0
      })
    })

  }

  // componentWillUnmount() {
  //   window.removeEventListener("popstate", this.handleBackButton);
  // }

  // handleBackButton = () => {
  //   console.log("Back button pressed");
  //   localStorage.removeItem("indent_id");
  //   window.history.back(); // 👈 go back one step
  // };


  // Keep all methods like onClickAcceptQuotation, submitNegotiateValue, onShowdata, cancelindent, onClickchangerankbtn here...
  getProposedQuantityFromNegotiation(vendor_email_id) {
    const negotiation = this.state.negotiations.find(
      n => n.vendor_email_id === vendor_email_id
    );
    return negotiation && negotiation.proposed_quantity !== undefined
      ? negotiation.proposed_quantity
      : ''; // or 0
  }
  resetindent = async () => {
    // await this.fetchInitialData();

  };

  submitNegotiateValue = (indent_id, vendor_email_id, indent_created_by, transit_time) => {
    let inputValue = ""
    let inputDays = ""

    if (localStorage.getItem("user_type") == "TRANSPORTER") {
      inputValue = this.state.vendorValues[vendor_email_id] || "";
      inputDays = this.state.vendorDays[vendor_email_id] || ""

    }
    else {
      inputValue = this.state.inputValue = this.state.proposedValues[vendor_email_id] || "";
      inputDays = this.state.proposedDays[vendor_email_id] || ""

    }

    if (inputValue === "" || inputDays === "") {
      this.setState({
        showsweetalert: true,
        basicType: 'danger',
        basicTitle: `Please Enter Amount and Days`,
      })
      return;
    }

    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      indent_id,
      negotiated_value: inputValue,
      negotiated_quantity: inputDays,
      vendor_email_id,
      indent_created_by
    };

    redirectURL.post("/consignments/submitNegotiateValue", params)
      .then(response => {
        const { status, message } = response.data;
        let user_type = localStorage.getItem('user_type')
        this.setState({
          showsweetalert: true,
          basicType: status === 'success' ? 'success' : 'danger',
          basicTitle: status === 'success'
            ? (user_type === 'TRANSPORTER' ? 'Your negotiation value has been submitted' : 'Your Proposed value has been submitted')
            : 'Please Enter Amount and Days',
          showBidDetailsSlider: false

        });
        // this.resetindent();
        emitDataReceived({})

        if (status === "success") {
          this.setState({
            isProposedInputOpen: "",
            isVendorInputOpen: ""
          });
        }
      })
      .catch(error => {
        this.setState({
          showsweetalert: true,
          basicType: "danger",
          basicTitle: "An error occurred while submitting the negotiation."
        });
      });
  };
  onShowdata = (indent_id) => {
    this.setState({
      vehicleDetailsModel: true,
      overlay: 'show-m',
    });
    const params = {
      indent_id: indent_id,
      vendor_email_id: localStorage.getItem('email')
    };

    redirectURL.post('/consignments/getstroreddata', params).then(resp => {
      const data1 = resp.data;
      const destinations = data1.map(e => ({
        indent_id: indent_id,
        dealer_city: e.dealer_city,
        dealer_pincode: e.dealer_pincode,
        bid_price: e.bid_price,
        truck_no: e.truck_no,
        lr_no: e.lr_no
      }));
      this.setState({ indent_for_approve1: destinations });
    });
  };
  onCloseModal = () => {
    this.setState({
      modelForAdditionalComments: false,
      modelForShowBids: false,
      modelForNotifications: false,
      modelForEditAssigned: false,
      vehicleDetailsModel: false,
      cardforadminbifurcation: false,
      adminbifurComment: '',
      rejectModelOpen: false,
      cancelModelOpen: false,
      declineModel: false,
      modelForNotifications: false,
      overly: 'show-n',
      overlay: 'show-n',

    });
  };
  handleDatesSelected = (start, end) => {
    this.setState({
      selectedfromdate: start.format("YYYY-MM-DD"),
      selectedenddate: end.format("YYYY-MM-DD")
    });
  };
  handleClickOutside(event) {
    if (
      this.tooltipRef &&
      !this.tooltipRef.contains(event.target) &&
      this.dotsRef &&
      !this.dotsRef.contains(event.target)
    ) {
      this.setState({ showTooltip: false });
    }
  }

  refreshSelected = () => {
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

    this.setState({
      selectedfromdate: oneWeekAgo,
      selectedenddate: today
    });
  };

  handleDatesChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  handleDelegatedClick = (e) => {
    const editIcon = e.target.closest('.icon-edit-proposed');
    const submitIcon = e.target.closest('.icon-submit-proposed');
    const acceptBtn = e.target.closest('.btn-accept');

    if (acceptBtn) {
      const indentId = acceptBtn.getAttribute('data-indentid');
      const bidPrice = acceptBtn.getAttribute('data-price');
      const qty = acceptBtn.getAttribute('data-qty');
      const email = acceptBtn.getAttribute('data-email');
      const createdBy = acceptBtn.getAttribute('data-createdby');
      const vendorValue = acceptBtn.getAttribute('data-vendorvalue');

      const originalIndent = this.state.originalindents.find(i => i.indent_id === indentId);

      if (originalIndent) {
        this.onClickAcceptQuotation(
          indentId,
          bidPrice,
          qty,
          email,
          createdBy,
          originalIndent,
          vendorValue
        );
      }

      return;
    }
    // -------- Handle Edit / Plus Icon --------
    if (editIcon) {
      const key = editIcon.getAttribute('data-key');
      const email = editIcon.getAttribute('data-email');

      const match = this.state.negotiations.find(function (item) {
        return item.vendor_email_id === email;
      });

      const proposedVal = match && match.proposed_value ? match.proposed_value : '';

      this.setState({
        isProposedInputOpen: key,
        inputTextValue: proposedVal
      }, () => {
        // 🔄 Force re-render of open detail rows
        if (this.gridApi) {
          this.gridApi.forEachNode(function (node) {
            if (node.expanded) {
              node.setExpanded(false);
              setTimeout(function () {
                node.setExpanded(true);
              }, 0);
            }
          });
        }
      });

      return;
    }

    // -------- Handle Submit Icon --------
    if (submitIcon) {
      const key = submitIcon.getAttribute('data-key');
      const email = submitIcon.getAttribute('data-email');
      const indentId = submitIcon.getAttribute('data-indent');
      const createdBy = submitIcon.getAttribute('data-createdby');
      const inputEl = document.getElementById('input-' + key);

      if (!inputEl) return;

      const value = inputEl.value;

      const existing = this.state.negotiations.find(function (e) {
        return e.vendor_email_id === email;
      });

      const previousValue = existing && existing.proposed_value ? existing.proposed_value : '';

      if (!value) {
        this.setState({
          showsweetalert: true,
          basicType: 'danger',
          basicTitle: 'Negotiation value cannot be empty'
        });
        return;
      }

      if (value === previousValue) {
        this.setState({
          showsweetalert: true,
          basicType: 'danger',
          basicTitle: 'Negotiation value cannot be the same as the previous one'
        });
        return;
      }

      this.setState({ inputTextValue: value }, () => {
        if (this.submitNegotiateValue) {
          this.submitNegotiateValue(indentId, email, createdBy);
        }
      });

      return;
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
  }

  transformIndentData = () => {
    const transformedData = this.state.allindents.map(indent => {
      let destinationStr = '';
      let materialStr = '';

      try {
        const dest = JSON.parse(indent.destination || '[]');
        destinationStr = dest.map(d => d.dealer_city).join(', ');
        materialStr = dest.flatMap(d => d.materials || [])
          .map(m => m.material_type)
          .join(', ');

      } catch { }

      return {
        indent_id: indent.indent_id || indent.draft_id,
        status: this.getStatusFromIndent(indent),
        source: indent.source,
        destination: destinationStr,
        bidding_window: indent.bidding_window,
        material: materialStr,
        truck_type: indent.type === 'sea' ? indent.container_type : (indent.type_of_truck === 'others' ? indent.selected_truck_type : indent.type_of_truck),
        pickup_date: getHyphenDDMMYYYY(indent.pickup_date),
        quantity: `${indent.confirmed_quantity}/${indent.quantity}`,
        confirmed_value: indent.confirmed_value || 'N/A',
        base_price: indent.base_price || '0',
        total_km: indent.total_km || '0',
        bid_start_date: getHyphenDDMMYYYYHHMM(indent.bid_start_date),
        vendor_count: (indent.vendorquotes && indent.vendorquotes.length) || 0,
        quotation_validity_hours: indent.quotation_validity_hours,
        indent
      };
    });

    this.setState({ rowData: transformedData, transformIndentrowdata: transformedData });
  }
  fetchData = () => {
    this.fetchInitialData();
    this.getdraftdata();
  };
  getcountersforindents = (data, draftData) => {
    let indentsdata = data;
    let totaldata;
    let expireddata;
    const userRole = localStorage.getItem('roles');
    const currentUserEmail = localStorage.getItem('email');

    if (localStorage.getItem('rfq_role') == 'ADMIN') {
      expireddata = indentsdata.filter(e => e.rejected != 1 && e.indent_assigned != 1)
      expireddata = expireddata.filter(item =>
        (
          this.isBiddingWindowExpired(item.bidding_window, item.create_date) && item.rejected != 1 &&
          item.vendorquotes.length === 0
        ) ||
        item.validity_end === 1 ||
        item.vehicle_placement_expiried === 1
      );
    } else {
      const username = localStorage.getItem('username');
      const userEmail = localStorage.getItem('email');

      expireddata = indentsdata.filter(item => {
        const vendorQuotes = item.vendorquotes || [];

        const isExpired =
          item.validity_end === 1 ||
          item.vehicle_placement_expiried === 1 ||
          this.isBiddingWindowExpired(item.bidding_window, item.create_date);

        const notQuoted = !vendorQuotes.some(x => x.vendor_email_id === userEmail);

        const declinedByCurrentUser =
          item.vendors_participation &&
          item.vendors_participation.hasOwnProperty(username) &&
          item.vendors_participation[username] === 'declined';

        return (isExpired) && !declinedByCurrentUser && item.rejected != 1 && item.indent_assigned != 1 && item.waiting_for_approval1 != 1;
      });


    }


    let awardeddata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      awardeddata = indentsdata.filter(e => e.accepted_vendor === localStorage.getItem('email') && e.vehicle_placement_expiried != 1 && e.rejected != 1 && e.validity_end != 1);
      awardeddata = awardeddata.filter((e) => {
        if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
          const vendorquote = e.vendorquotes.find(
            (quote) =>
              (quote.vendor_email_id === localStorage.getItem('email') &&
                quote.indent_rejected_by_vendor != 1 &&
                quote.indent_accepted_by_vendor === 1) ||
              quote.bid_winner == 1
          );
          return vendorquote !== undefined;
        }
      });
    } else {
      awardeddata = indentsdata.filter(e => e.indent_assigned == 1 && e.indent_rejected_by_vendor != 1 && e.vehicle_placement_expiried != 1 && e.indent_cancelled != 1 && e.rejected != 1);
    }

    let activedata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      const userEmail = localStorage.getItem('email');

      activedata = indentsdata.filter((e) => {
        const hasValidVendorDetails = e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned !== 1 && e.validity_end !== 1 && e.approvedwithapproval2 !== 1 && e.rejected !== 1;
        const hasPendingDifferentVendor = e.indent_pending_data && e.indent_pending_data.vendor_email_id !== userEmail;
        const hasPreviousDifferentVendorAndMatchingQuote =
          e.previous_accepted_vendor !== userEmail &&
          e.vendorquotes &&
          e.vendorquotes.some(f => f.vendor_email_id === userEmail) &&
          e.vendorquotes.find(g => g.bid_winner != 1);

        const isExpiredWithNoQuote =
          this.isBiddingWindowExpired(e.bidding_window, e.create_date) &&
          (!e.vendorquotes || !e.vendorquotes.some(q => q.vendor_email_id === userEmail));

        return (hasValidVendorDetails || hasPendingDifferentVendor || hasPreviousDifferentVendorAndMatchingQuote) && !isExpiredWithNoQuote;
      });
      let username = localStorage.getItem('username');

      activedata = activedata.filter(
        (e) =>
          e.previous_accepted_vendor !== userEmail &&
          e.indentcancelledbyadmin !== 1 &&
          e.indent_cancelled !== 1 &&
          e.approvedwithapproval2 !== 1 &&
          e.rejected !== 1 &&
          (
            !e.vendors_participation || // if no participation object, allow
            !e.vendors_participation.hasOwnProperty(username) || // if no user key, allow
            e.vendors_participation[username] !== 'declined' // only check if both above are true
          )
      );


      activedata = activedata.filter((e) => {
        const vendorquotes = e.vendorquotes || [];
        if (vendorquotes.length > 0 && vendorquotes.some(quote => quote.vendor_email_id === userEmail)) {
          const vendorquote = vendorquotes.find(
            (quote) =>
              quote.vendor_email_id === userEmail &&
              quote.indent_rejected_by_vendor !== 1 &&
              quote.indent_accepted_by_vendor !== 1 &&
              quote.vendor_rejected !== 1 &&
              e.validity_end !== 1 &&
              e.approvedwithapproval2 !== 1
          );
          return vendorquote !== undefined;
        }
        return true;
      });
    } else {
      activedata = indentsdata.filter(e => e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned != 1 && e.validity_end != 1 && e.rejected != 1 && e.indentcancelledbyadmin != 1 && (
        e.vendorquotes.length > 0 ||
        !this.isBiddingWindowExpired(e.bidding_window, e.create_date)
      ));
    }

    const completeddata = indentsdata.filter(e => e.validity_end == 1);

    let rejecteddata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      rejecteddata = indentsdata.filter(e => e.previous_accepted_vendor != localStorage.getItem('email'))
      rejecteddata = rejecteddata.filter((e) => {
        const isRejected = e.rejected == 1 && (e.vendorquotes.some(q => q.vendor_email_id === localStorage.getItem('email'))) && e.indent_rejected_by_vendor != 1;

        let isVendorMatch = false;
        if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
          const vendorquote = e.vendorquotes.find((quote) => {
            return (
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.bid_winner === 0 &&
              quote.pending_vendor_approval == 1 &&
              e.approvedwithapproval2 == 1 &&
              e.accepted_vendor != localStorage.getItem('email')
            );
          });
          isVendorMatch = vendorquote !== undefined;
        }

        return isRejected || isVendorMatch;
      });
    } else {
      rejecteddata = indentsdata.filter(e => e.rejected == 1 || e.rejectedwithapproval1 == 1);
    }

    let vendorrejecteddata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      const userEmail = localStorage.getItem('email');
      const username = localStorage.getItem('username');

      vendorrejecteddata = indentsdata.filter(e => {
        const q = e.vendorquotes || [];

        // true when this user is marked "declined" on the item
        const declinedByCurrentUser =
          e.vendors_participation &&
          e.vendors_participation.hasOwnProperty(username) &&
          e.vendors_participation[username] === 'declined';

        // ───── condition1: vendor rejected ─────
        const condition1 =
          (
            q.find(
              quote =>
                quote.vendor_email_id === userEmail &&
                quote.indent_rejected_by_vendor === 1
            ) &&
            e.validity_end !== 1 &&
            e.rejected != 1 &&
            e.vehicle_placement_expiried !== 1 &&
            e.rejectedwithapproval2 !== 1
          ) ||
          declinedByCurrentUser;

        // ───── condition2: previously accepted vendor ─────
        const condition2 =
          (
            e.previous_accepted_vendor === userEmail &&
            e.validity_end !== 1 &&
            e.vehicle_placement_expiried !== 1 &&
            e.rejectedwithapproval2 !== 1
          ) ||
          declinedByCurrentUser;
        const condition3 =
          (
            q.some(qi => qi.vendor_email_id != userEmail) && e.indent_rejected_by_vendor == 1

          )
        const condition4 =
          (
            e.previous_accepted_vendor == localStorage.getItem('email')
          )
        return condition1 || condition2 || condition3 || condition4
      });
    }
    else {
      vendorrejecteddata = indentsdata.filter(e => e.indent_rejected_by_vendor == 1 && e.rejected != 1 && e.indentcancelledbyadmin != 1);
    }

    const cancelleddata = indentsdata.filter(e => e.indentcancelledbyadmin == 1);
    const draftdata = draftData;

    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      totaldata = [...expireddata, ...awardeddata, ...activedata, ...vendorrejecteddata, ...rejecteddata];
    } else {
      totaldata = [...expireddata, ...awardeddata, ...activedata, ...vendorrejecteddata, ...rejecteddata, ...draftdata];
    }

    this.setState({
      countersfortab: {
        totalcount: totaldata.length,
        activecount: activedata.length,
        awardcount: awardeddata.length,
        vendorrejectedcount: vendorrejecteddata.length,
        vehicleplacementmissedcount: cancelleddata.length,
        draftscount: draftdata.length,
        rejectedcount: rejecteddata.length,
        expiredcount: expireddata.length,
        deliveredcount: 0
      }
    });
  };
  // renderBasicField = (label, value) => (
  //   <div className="grid-item">
  //     <label className="field-title" style={{ fontWeight: 'bold', marginRight: '8px' }}>{label} :</label>
  //     <span className="field-value" style={{ color: '#333' }}>{value || 'N/A'}</span>
  //   </div>
  // );

  // renderDealerField = (label, value) => (
  //   <div className="grid-item">
  //     <label className="field-title mr-8p">{label} :</label>
  //     <span className="field-value">{value || "N/A"}</span>
  //   </div>
  // );

  formatCapitalize = (text) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : 'N/A';
  };

  getOptionsLabel = (optionsArray, value) => {
    const match = optionsArray.find(opt => opt.value === value);
    return match ? match.label : value;
  };

  getdraftdata = () => {
    // Placeholder
  };

  cancelindent = (indent, bid) => {
    this.setState({ rejectModelOpen: true, paramsforrejection: { indent, bid } });
  };
  onClickviewRFQ = async function (e) {
    let destination_info = e.data.indent
    const destinationDetails = JSON.parse(destination_info.destination || '[]');
    this.setState({
      isPreviewMode: true,
      rfqForm: e.data.indent,
      dealers: destinationDetails
    });
    // this.setState({ bidDetailsform: true });


  };

  // onClickComments = async function(e){
  //   let indent = e.data.indent
  //   const comment = indent && indent.additional_comments ? indent.additional_comments : 'No comments provided';
  //   this.setState({
  //       modelForAdditionalComments:true,
  //       additionalComments:comment
  //   })
  // }
  onClickComments = async function (e) {
    let indent = e.data.indent;

    const fields = [
      { label: 'Additional Comments', value: indent && indent.additional_comments },
      // { label: 'Vendor Rejection Reason', value: indent && indent.reasonforrejectionbyvendor },
      // { label: 'Admin Rejection Reason', value: indent && indent.rejected_reason_by_approval1 },
      // { label: 'Danish Rejection Reason', value: indent && indent.rejection_reason_for_superadmin },
    ];

    const comment = fields
      .filter(field => field.value)
      .map(field => field.label + ': ' + field.value)
      .join('\n');

    this.setState({
      modelForAdditionalComments: true,
      additionalComments: comment || 'No comments provided'
    });
  };

  onClickmaterialdetails = async (params) => {

    if (params != 0) {
      await this.setState({
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: [
              { headerName: "Dealer Code", field: "dealer_code", width: 150 },
              { headerName: "Dealer Name", field: "dealer_name", width: 200 },
              { headerName: "Dealer City", field: "dealer_city", width: 130 },
              { headerName: "Dealer State", field: "dealer_state", width: 160 },
              { headerName: "Dealer Pincode", field: "dealer_pincode", width: 130 },
              {
                headerName: "Material Type",
                field: "material_type",
                width: 180,
              },
              {
                headerName: "Dimensions(L x B x H)",
                valueGetter: function (params) {
                  var m = params.data;
                  const unit = m.material_units ? `(${m.material_units})` : '';
                  return `${m.material_length} x ${m.material_breath} x ${m.material_height} ${unit}`;
                },
                width: 200,
              }
              ,
              {
                headerName: "Quantity",
                field: "quantity",
                width: 100,
              },
              {
                headerName: "Prerequisite",
                field: "basic_requirment",
                width: 180,
              }
            ]
          },

          getDetailRowData: function (params) {
            var indent = params && params.data && params.data.indent;
            var destinationRaw = indent && indent.destination;
            var rowData = [];

            try {
              var destinations = JSON.parse(destinationRaw);

              destinations.forEach(function (dest) {
                dest.materials.forEach(function (material) {
                  rowData.push(Object.assign({}, dest, material));
                });
              });
            } catch (err) {
              console.error("Invalid JSON in destination:", err);
            }
            params.successCallback(rowData);
          }.bind(this),

          masterDetail: true
        }
      });


    }
    if (params.column.colDef.field == 'materials') {
      params.node.setExpanded(!params.node.expanded);
    }
    else {

      params.node.setExpanded(false);
    }
  }

  onClickallcomments = async (params) => {
    if (params !== 0) {
      await this.setState({
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: [
              {
                headerName: "Indent ID",
                field: "indent_id",
                width: 120,
                resizable: true,

              },
              {
                headerName: "Action",
                field: "action",
                width: 300,
                resizable: true,

              },
              {
                headerName: "Action By",
                field: "action_by",
                resizable: true,


              },
              {
                headerName: "Action Date & Time",
                field: "action_time",
                resizable: true,

                valueFormatter: function (params) {
                  if (!params.value) return '';
                  return getHyphenDDMMYYYYHHMM(params.value)
                },
                cellStyle: { textTransform: 'capitalize' }
              },
              {
                headerName: "Remarks",
                field: "remarks",
                width: 200,
                resizable: true,

              },
            ]
          },
          getDetailRowData: function (gridParams) {
            var indent = gridParams && gridParams.data && gridParams.data.indent;
            if (!indent) {
              gridParams.successCallback([]);
              return;
            }

            var requestParams = { indent_id: indent.indent_id };

            redirectURL.post('/consignments/getallactionlogs', requestParams)
              .then(function (response) {
                if (response.data && Array.isArray(response.data)) {
                  let data = response.data;


                  // Sort data by latest action_time first
                  data.sort((a, b) => new Date(b.action_time) - new Date(a.action_time));

                  // Remove Duplicate Actions (unique by 'action' text)
                  const uniqueActionsMap = new Map();
                  const uniqueData = [];

                  data.forEach(item => {
                    if (!uniqueActionsMap.has(item.action)) {
                      uniqueActionsMap.set(item.action, true);
                      uniqueData.push(item);
                    }
                  });

                  gridParams.successCallback(uniqueData);
                } else {
                  gridParams.successCallback([]);
                }
              })
              .catch(function (error) {
                console.error('Failed to fetch action logs:', error);
                gridParams.successCallback([]);
              });
          },

          masterDetail: true
        }
      });
    }

    if (params.column && params.column.colDef && params.column.colDef.field === 'allcomments') {
      params.node.setExpanded(!params.node.expanded);
    } else {
      params.node.setExpanded(false);
    }
  };

  onClickshowparticipants = async (params) => {
    // this.setState({ loadshow: "show-m" });
    if (params != 0) {

      await this.setState({

        detailCellRendererParams: {
          detailGridOptions: {

            columnDefs: [
              // {
              //   headerName: "Indent ID",
              //   field: "indent_id",
              //   width: 160,
              //   cellRenderer: "Actionsforvendorcomponent",
              //   filter: false,
              // },
              {
                headerName: "Vendor Name",
                field: "vendor",
                width: 160,
                cellRenderer: "Actionsforvendorcomponent",
                filter: false,
              },
              {
                headerName: "Participation Status",
                field: "status",
                filter: false,
                cellStyle: params => {
                  const status = (params.value || "").toLowerCase();
                  let color = 'black';

                  if (status === 'accepted') {
                    color = 'green';
                  } else if (status === 'declined') {
                    color = 'red';
                  } else if (status === 'not responded') {
                    color = 'blue';
                  }

                  return {
                    color: color,
                    fontWeight: 'bold',
                    textTransform: 'capitalize'
                  };
                }
              }
              ,
              {
                headerName: "Remarks",
                field: "remarks",
              }


            ]
          },

          getDetailRowData: async function (params) {
            const indent = params && params.data && params.data.indent;
            const participation = indent.vendors_participation1 || {};
            const declinedReasons = indent.vendors_declined_reason1 || {};
            const vendorNamesArray = [];

            try {
              vendorNamesArray.push(...JSON.parse(indent.vendors_names));  // ["Jai Mata Logistics", "VRL Logistics", "NEGL"]
            } catch (e) {
              console.error("Invalid vendors_names format", e);
            }

            // Add "Not Responded" status for vendors not in participation
            for (const vendorName of vendorNamesArray) {
              if (!participation.hasOwnProperty(vendorName)) {
                participation[vendorName] = "No Response";
              }
            }

            const rowData = [];
            const addedVendors = new Set(); // Track already added vendor names

            for (const vendorName in participation) {
              const status = participation[vendorName];

              // Avoid duplicates
              const uniqueKey = vendorName.toLowerCase();
              if (addedVendors.has(uniqueKey)) continue;

              let remarks = "";
              if (status.toLowerCase() === "declined") {
                remarks = declinedReasons[vendorName] || "";
              }

              rowData.push({
                vendor: vendorName,
                status: status,
                remarks: remarks,
                indent_id: indent.indent_id,
                indent: indent
              });

              addedVendors.add(uniqueKey);
            }
            params.successCallback(rowData);
          }.bind(this),



          masterDetail: true
        }
      });

    }
    if (params.column.colDef.field == 'vendor_count') {
      params.node.setExpanded(!params.node.expanded);
    }
    else {

      params.node.setExpanded(false);
    }
  }

  onClickacceptparticipation = (params) => {
    let e = params.data
    redirectURL.post('/consignments/storeaccepflag', { 'indent_id': e.indent_id, 'vendor_name': localStorage.getItem('username'), 'vendor_email_id': localStorage.getItem('email') }).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'Successfully Accepted',
        rejectModelOpen: false
      });
      this.resetindent()

    })
  }
  onClickdeclineparticipation = (params) => {
    this.setState({ declineModel: true, declinedata: params.data });

    // let e = params.data
    // redirectURL.post('/consignments/storedeclineflag',{'indent_id':e.indent_id,'vendor_name':localStorage.getItem('username')}).then((resp)=>{
    //   this.setState({
    //     show: true,
    //     basicType: 'success',
    //     basicTitle: 'Successfully Declined',
    //     rejectModelOpen: false
    //   });
    //   this.resetindent()
    //   })
  }
  onClickdeclineparticipation1 = () => {
    let e = this.state.declinedata
    redirectURL.post('/consignments/storedeclineflag', { declinereasonforvendor: this.state.declinereasonforvendor, 'indent_id': e.indent_id, 'vendor_name': localStorage.getItem('username'), 'email': localStorage.getItem('email') }).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: `Indent ${e.indent_id} Successfully Declined`,
        declineModel: false,
        rejectModelOpen: false
      });
      this.resetindent()
    })
  }

  onClickbiddetails = async (params) => {
    let e = params.data
    this.setState({
      selected_for_placebid: e.indent_id
    })
    this.setState({
      overlay: 'show-m',
      showsliderforbid: true,
    });

    const { originalindents } = this.state;

    // Set selected indent and fetch bid history
    this.setState((prevState) => {
      const currentlyOpen = prevState.iscardOpen;
      if (currentlyOpen === e.indent_id) {
        return {
          iscardOpen: "",
          selectedindent: {},
        };
      } else {
        this.getbidhistory(e.indent_id);
        return {
          iscardOpen: e.indent_id,
          selectedindent: e,
        };
      }
    });

    // Filter original indent and prepare destinations
    const data = originalindents.filter((f) => f.indent_id === e.indent_id);
    let destinations = [];
    let data1 = JSON.parse(data[0].destination);

    data1.forEach((g) => {
      destinations.push({
        indent_id: e.indent_id,
        dealer_city: g.dealer_city,
        dealer_pincode: g.dealer_pincode,
        dealer_code: g.dealer_code,
        quantity: g.quantity,
      });
    });

    // Fetch stored data and update bid/transit days
    const paramsStored = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem("email"),
    };

    redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      const transit_data = resp.data;

      transit_data.forEach((record) => {
        const match = destinations.find(
          (d) =>
            d.indent_id === record.indent_id &&
            d.dealer_city === record.dealer_city
        );
        if (match) {
          match.bid_price = record.bid_price;
          match.transit_days = record.transit_days;
        }
      });

      this.setState({
        indent_for_approve_for_bid: destinations,
        indent_for_approve_for_bid1: destinations,
      });
    });

    this.setState({
      inputTextValue: "",
      inputTextQuantity: "",
    });

    // Fetch LR data
    const paramsLR = { indent_id: e.indent_id };

    redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
      const data = resp.data;
      if (data && data !== "") {
        if (localStorage.getItem("roles") === "TRANSPORTER") {
          // If needed: filter by vendor_email_id
          // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
          this.setState({ lr_no_data: data });
        } else {
          this.setState({ lr_no_data: data });
        }
      }
    });

    // Fetch stored truck details
    redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      const data1 = resp.data;
      let destinations = [];

      data1.forEach((f) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: f.dealer_city,
          dealer_pincode: f.dealer_pincode,
          bid_price: f.bid_price,
          truck_no: f.truck_no,
          transit_days: f.transit_days,
          material: f.material,
        });
      });

      let indentfortruckdetails = [];
      data1.forEach((g) => {
        indentfortruckdetails.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          bid_price: g.bid_price,
          truck_no: g.truck_no,
          lr_no: g.lr_no,
        });
      });

      this.setState({
        indent_for_approve1: destinations,
        indentfortruckdetails: indentfortruckdetails,
      });
    });
  };
  gethistorydata = async (params) => {

    const indentId = params

    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        // overlay:'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs
      });

    } catch (error) {
      console.error("Error loading bid data:", error);
    }
  };
  // onClickshowbiddata = async (params) => {
  //   const indent = params.data && params.data.indent;
  //   if (!indent) return;

  //   const indentId = indent.indent_id;

  //   try {
  //     // Reset Data Ready Counter
  //     let dataReadyCount = 0;
  //     const requiredAPIcalls = 3;  // Total API calls that must finish before opening slider

  //     // Common Checker to Open Slider after all data is fetched
  //     const checkAndOpenSlider = () => {
  //       dataReadyCount++;
  //       if (dataReadyCount === requiredAPIcalls) {
  //         this.setState({ showBidDetailsSlider: true });
  //       }
  //     };

  //     // 1. Get Bid History
  //     const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });
  //     const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
  //     const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
  //     const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

  //     const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

  //     this.setState({
  //       overlay: 'show-m',
  //       selectedIndentData: originalIndent,
  //       selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
  //       bidHistory,
  //       negotiations,
  //       negotiationsLogs,
  //       selectedindentdata1: params.data
  //     });

  //     // Card Open/Close Handling
  //     this.setState((prevState) => {
  //       const currentlyOpen = prevState.iscardOpen;
  //       if (currentlyOpen === indentId) {
  //         return {
  //           iscardOpen: "",
  //           selectedindent: {},
  //         };
  //       } else {
  //         this.getbidhistory(indentId);
  //         return {
  //           iscardOpen: indentId,
  //           selectedindent: params.data,
  //         };
  //       }
  //     });

  //     // 2. Fetch & Process Truck Details and Stored Data
  //     const paramsStored = {
  //       indent_id: indentId,
  //       vendor_email_id: localStorage.getItem("email"),
  //     };

  //     // Fetch and Process Stored Data for Truck Details
  //     redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
  //       const data1 = resp.data;
  //       let destinations = [];
  //       data1.forEach((f) => {
  //         destinations.push({
  //           indent_id: indentId,
  //           dealer_city: f.dealer_city,
  //           dealer_pincode: f.dealer_pincode,
  //           truck_no: f.truck_no,
  //           transit_days: f.transit_days,
  //           material: f.material,
  //         });
  //       });

  //       let indentfortruckdetails = [];
  //       data1.forEach((g) => {
  //         indentfortruckdetails.push({
  //           indent_id: indentId,
  //           dealer_city: g.dealer_city,
  //           dealer_pincode: g.dealer_pincode,
  //           dealer_code: g.dealer_code,
  //           truck_no: g.truck_no,
  //           lr_no: g.lr_no,
  //         });
  //       });

  //       this.setState({
  //         indent_for_approve1: destinations,
  //         indentfortruckdetails: indentfortruckdetails,
  //       }, () => checkAndOpenSlider());  // Increment Counter after this API completes
  //     });

  //     // 3. Fetch LR No Data
  //     const paramsLR = { indent_id: indentId };
  //     redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
  //       const data = resp.data;
  //       this.setState({ lr_no_data: data }, () => checkAndOpenSlider());  // Increment Counter
  //     });

  //     // 4. Fetch Bifurcation Data for Admin
  //     const paramsBifur = { indent_id: indentId };
  //     redirectURL.post('/consignments/getadminbifurdata', paramsBifur).then((resp) => {
  //       const records = resp.data;
  //       const bifurdata = records.map((g) => ({
  //         indent_id: indentId,
  //         dealer_city: g.dealer_city,
  //         dealer_state: g.dealer_state,
  //         dealer_pincode: g.dealer_pincode,
  //         dealer_name: g.dealer_name,
  //         dealer_code: g.dealer_code,
  //         bid_price: g.bid_price,
  //         quantity: g.quantity,
  //       }));

  //       this.setState({
  //         dataforadminbifur: bifurdata,
  //         indentfortruckdetails: bifurdata,
  //       }, () => checkAndOpenSlider());  // Increment Counter
  //     });

  //     // Reset Inputs (optional)
  //     this.setState({
  //       inputTextValue: "",
  //       inputTextQuantity: "",
  //     });
  // // this.onClickBidNow(indent)
  //   } catch (error) {
  //     console.error("Error loading bid data:", error);
  //   }
  // };
  closeConfirmationModal = () => {
    this.setState({ showConfirmationModal: false, confirmMessage: "", confirmActionCallback: null });
  };

  onClickentertruckdetails = async (params) => {
    const indent = params.data && params.data.indent;
    if (!indent) return;

    const indentId = indent.indent_id;

    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        overlay: 'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs,
        selectedindentdata1: params.data
      });
      //   this.onClickbiddetails()

      let e = params.data

      const { originalindents } = this.state;

      // Set selected indent and fetch bid history
      this.setState((prevState) => {
        const currentlyOpen = prevState.iscardOpen;
        if (currentlyOpen === e.indent_id) {
          return {
            iscardOpen: "",
            selectedindent: {},
          };
        } else {
          this.getbidhistory(e.indent_id);
          return {
            iscardOpen: e.indent_id,
            selectedindent: e,
          };
        }
      });

      // Filter original indent and prepare destinations
      const data = originalindents.filter((f) => f.indent_id === e.indent_id);
      let destinations = [];
      let data1 = JSON.parse(data[0].destination);

      data1.forEach((g) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          quantity: g.quantity,
        });
      });

      // Fetch stored data and update bid/transit days
      const paramsStored = {
        indent_id: e.indent_id,
        vendor_email_id: localStorage.getItem("email"),
      };

      redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
        const transit_data = resp.data;

        transit_data.forEach((record) => {
          const match = destinations.find(
            (d) =>
              d.indent_id === record.indent_id &&
              d.dealer_city === record.dealer_city
          );
          if (match) {
            match.bid_price = record.bid_price;
            match.transit_days = record.transit_days;
          }
        });

        this.setState({
          indent_for_approve_for_bid: destinations,
          indent_for_approve_for_bid1: destinations,
        });
      });

      this.setState({
        inputTextValue: "",
        inputTextQuantity: "",
      });

      // Fetch LR data
      const paramsLR = { indent_id: e.indent_id };

      redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
        const data = resp.data;
        if (data && data !== "") {
          if (localStorage.getItem("roles") === "TRANSPORTER") {
            // If needed: filter by vendor_email_id
            // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
            this.setState({ lr_no_data: data });
          } else {
            this.setState({ lr_no_data: data });
          }
        }
      });

      // Fetch stored truck details
      // redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      //   const data1 = resp.data;
      //   let destinations = [];

      //   data1.forEach((f) => {
      //     destinations.push({
      //       indent_id: e.indent_id,
      //       dealer_city: f.dealer_city,
      //       dealer_pincode: f.dealer_pincode,
      //       truck_no: f.truck_no,
      //       transit_days: f.transit_days,
      //       material: f.material,
      //     });
      //   });

      //   let indentfortruckdetails = [];
      //   data1.forEach((g) => {
      //     indentfortruckdetails.push({
      //       indent_id: e.indent_id,
      //       dealer_city: g.dealer_city,
      //       dealer_pincode: g.dealer_pincode,
      //       dealer_code: g.dealer_code,
      //       truck_no: g.truck_no,
      //       lr_no: g.lr_no,
      //     });
      //   });

      //   this.setState({
      //     indent_for_approve1: destinations,
      //     indentfortruckdetails: indentfortruckdetails,
      //   });
      // });
      var params = {
        "indent_id": e.indent_id
      }
      redirectURL.post('/consignments/getadminbifurdata', params).then((resp) => {
        var bifurdata = []
        var records = resp.data
        records.map((g) => {
          bifurdata.push({
            "indent_id": e.indent_id,
            "dealer_city": g.dealer_city,
            "dealer_state": g.dealer_state,
            'dealer_pincode': g.dealer_pincode,
            "dealer_name": g.dealer_name,
            "dealer_code": g.dealer_code,
            "bid_price": g.bid_price,
            "quantity": g.quantity,

          })
        })

        this.setState({
          dataforadminbifur: bifurdata,
          indentfortruckdetails: bifurdata
        }, () => {
          // This will execute after state is updated
          this.setState({
            showBidDetailsSlider1: true // Open Modal AFTER data is ready
          });
        });



      })
    }
    catch (error) {
      console.error("Error loading bid data:", error);
    }
  };
  onClickshowbiddata = async (params) => {
    const indent = params.data && params.data.indent;
    if (!indent) return;

    const indentId = indent.indent_id;

    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        overlay: 'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs,
        selectedindentdata1: params.data
      });
      //   this.onClickbiddetails()

      let e = params.data

      const { originalindents } = this.state;

      // Set selected indent and fetch bid history
      this.setState((prevState) => {
        const currentlyOpen = prevState.iscardOpen;
        if (currentlyOpen === e.indent_id) {
          return {
            iscardOpen: "",
            selectedindent: {},
          };
        } else {
          this.getbidhistory(e.indent_id);
          return {
            iscardOpen: e.indent_id,
            selectedindent: e,
          };
        }
      });

      // Filter original indent and prepare destinations
      const data = originalindents.filter((f) => f.indent_id === e.indent_id);
      let destinations = [];
      let data1 = JSON.parse(data[0].destination);

      data1.forEach((g) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          quantity: g.quantity,
        });
      });

      // Fetch stored data and update bid/transit days
      const paramsStored = {
        indent_id: e.indent_id,
        vendor_email_id: localStorage.getItem("email"),
      };

      redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
        const transit_data = resp.data;

        transit_data.forEach((record) => {
          const match = destinations.find(
            (d) =>
              d.indent_id === record.indent_id &&
              d.dealer_city === record.dealer_city
          );
          if (match) {
            match.bid_price = record.bid_price;
            match.transit_days = record.transit_days;
          }
        });

        this.setState({
          indent_for_approve_for_bid: destinations,
          indent_for_approve_for_bid1: destinations,
        });
      });

      this.setState({
        inputTextValue: "",
        inputTextQuantity: "",
      });

      // Fetch LR data
      const paramsLR = { indent_id: e.indent_id };

      redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
        const data = resp.data;
        if (data && data !== "") {
          if (localStorage.getItem("roles") === "TRANSPORTER") {
            // If needed: filter by vendor_email_id
            // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
            this.setState({ lr_no_data: data });
          } else {
            this.setState({ lr_no_data: data });
          }
        }
      });

      // Fetch stored truck details
      // redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      //   const data1 = resp.data;
      //   let destinations = [];

      //   data1.forEach((f) => {
      //     destinations.push({
      //       indent_id: e.indent_id,
      //       dealer_city: f.dealer_city,
      //       dealer_pincode: f.dealer_pincode,
      //       truck_no: f.truck_no,
      //       transit_days: f.transit_days,
      //       material: f.material,
      //     });
      //   });

      //   let indentfortruckdetails = [];
      //   data1.forEach((g) => {
      //     indentfortruckdetails.push({
      //       indent_id: e.indent_id,
      //       dealer_city: g.dealer_city,
      //       dealer_pincode: g.dealer_pincode,
      //       dealer_code: g.dealer_code,
      //       truck_no: g.truck_no,
      //       lr_no: g.lr_no,
      //     });
      //   });

      //   this.setState({
      //     indent_for_approve1: destinations,
      //     indentfortruckdetails: indentfortruckdetails,
      //   });
      // });
      var params = {
        "indent_id": e.indent_id
      }
      redirectURL.post('/consignments/getadminbifurdata', params).then((resp) => {
        var bifurdata = []
        var records = resp.data
        records.map((g) => {
          bifurdata.push({
            "indent_id": e.indent_id,
            "dealer_city": g.dealer_city,
            "dealer_state": g.dealer_state,
            'dealer_pincode': g.dealer_pincode,
            "dealer_name": g.dealer_name,
            "dealer_code": g.dealer_code,
            "bid_price": g.bid_price,
            "quantity": g.quantity,

          })
        })

        this.setState({
          dataforadminbifur: bifurdata,
          indentfortruckdetails: bifurdata
        }, () => {
          // This will execute after state is updated
          this.setState({
            bidDetailsform: true,
            // showBidDetailsSlider: true // Open Modal AFTER data is ready
          });
        });



      })
    }
    catch (error) {
      console.error("Error loading bid data:", error);
    }
  };

  onclickreject = () => {
    const params = { ...this.state.paramsforrejection };
    params.rejected_reason_by_approval1 = this.state.rejectionReasonbyapproval1;
    redirectURL.post('/consignments/cancelindentbyapproval1', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: `Indent ${params.indent.indent_id} has been rejected successfully`,
        rejectModelOpen: false,
        showBidDetailsSlider: false
      });
      // this.resetindent();
      emitDataReceived({})
    });
  };

  fetchInitialData = () => {
    this.setState({ loadshow: "show-m" });

    const { selectedfromdate, selectedenddate } = this.state;
    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      from_date: selectedfromdate,
      to_date: selectedenddate
    };

    redirectURL.post("/consignments/fetchRFQsForDashboard", params).then((response) => {
      const record = response.data || [];
      const data = record.filter(e => e.is_draft !== 1);
      const draftData = record.filter(e => e.is_draft === 1);
      let userEmail = localStorage.getItem('email')
      this.setState({
        draftdata: draftData,
        originalindents: data,
        alldata: data,
        indentsdata: data
      });

      this.getcountersforindents(data, draftData);

      let filterData = data;
      const rfqform = this.state.rfqform;

      if (rfqform.active === 'activet1') {
        const userType = localStorage.getItem('user_type');
        const userEmail = localStorage.getItem('email');

        if (userType === 'TRANSPORTER') {
          filterData = filterData.filter(e => {
            const hasValidVendorDetails = e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned !== 1 && e.validity_end !== 1 && e.rejected !== 1;
            const hasPendingDifferentVendor = e.indent_pending_data && e.indent_pending_data.vendor_email_id !== userEmail;
            const hasPreviousDifferentVendorAndMatchingQuote = e.previous_accepted_vendor !== userEmail && e.vendorquotes && e.vendorquotes.some(f => f.vendor_email_id === userEmail) && e.vendorquotes.find(g => g.bid_winner !== 1);
            const isExpiredWithNoQuote = this.isBiddingWindowExpired(e.bidding_window, e.create_date) && (!e.vendorquotes || !e.vendorquotes.some(q => q.vendor_email_id === userEmail));

            return (hasValidVendorDetails || hasPendingDifferentVendor || hasPreviousDifferentVendorAndMatchingQuote) && !isExpiredWithNoQuote;
          });

          filterData = filterData.filter(e =>
            e.previous_accepted_vendor !== userEmail &&
            e.indentcancelledbyadmin !== 1 &&
            e.indent_cancelled !== 1 &&
            e.approvedwithapproval2 !== 1 &&
            e.rejected !== 1
          );

          filterData = filterData.filter(e => {
            const vendorquotes = e.vendorquotes || [];
            if (vendorquotes.length > 0 && vendorquotes.some(quote => quote.vendor_email_id === userEmail)) {
              const vendorquote = vendorquotes.find(quote =>
                quote.vendor_email_id === userEmail &&
                quote.vendor_rejected !== 1 &&
                quote.indent_rejected_by_vendor !== 1 &&
                quote.indent_accepted_by_vendor !== 1 &&
                e.approvedwithapproval2 !== 1 &&
                e.validity_end !== 1
              );
              return vendorquote !== undefined;
            }
            return true;
          });
        } else {
          filterData = filterData.filter(e => e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned !== 1 && e.validity_end !== 1 && e.rejected !== 1 && e.indentcancelledbyadmin !== 1 || (
            e.vendorquotes.length > 0 ||
            !this.isBiddingWindowExpired(e.bidding_window, e.create_date)
          ));


        }
      }
      else if (rfqform.drafts == 'activet1') {
        filterData = draftData
      }
      else if (rfqform.awarded == 'activet1') {
        if (userType === 'TRANSPORTER') {
          filterData = filterData.filter(item =>
            item.accepted_vendor === userEmail &&
            item.vehicle_placement_expiried !== 1 &&
            item.rejected !== 1 &&
            item.validity_end !== 1
          ).filter(item => {
            const q = item.vendorquotes || [];
            const vendorquote = q.find(quote =>
              (quote.vendor_email_id === userEmail &&
                quote.indent_rejected_by_vendor !== 1 &&
                quote.indent_accepted_by_vendor === 1) ||
              quote.bid_winner === 1
            );
            return vendorquote !== undefined;
          });
        } else {
          filterData = filterData.filter(item =>
            item.indent_assigned === 1 &&
            item.indent_rejected_by_vendor !== 1 &&
            item.vehicle_placement_expiried !== 1 &&
            item.indent_cancelled !== 1 && item.rejected != 1
          );
        }
        filterData = filterData
      }
      else if (rfqform.vendorrejected == 'activet1') {
        if (userType === 'TRANSPORTER') {
          filterData = filterData.filter(item => {
            const q = item.vendorquotes || [];
            // current user
            const username = localStorage.getItem('username');

            // true when this user is marked "declined" on the item
            const declinedByCurrentUser =
              item.vendors_participation &&
              item.vendors_participation.hasOwnProperty(username) &&
              item.vendors_participation[username] === 'declined';

            /* ─────────────────────────  CONDITIONS  ───────────────────────── */

            const condition1 =
              (
                q.find(
                  quote =>
                    quote.vendor_email_id === userEmail &&
                    quote.indent_rejected_by_vendor === 1
                ) &&
                item.validity_end !== 1 &&
                item.vehicle_placement_expiried !== 1 &&
                item.rejectedwithapproval2 !== 1
              ) ||
              declinedByCurrentUser;

            const condition2 =
              (
                item.previous_accepted_vendor === userEmail &&
                item.validity_end !== 1 &&
                item.vehicle_placement_expiried !== 1 &&
                item.rejectedwithapproval2 !== 1
              ) ||
              declinedByCurrentUser;

            const condition3 =
              (
                q.some(qi => qi.vendor_email_id != userEmail) && item.indent_rejected_by_vendor == 1

              )
            const condition4 =
              (
                item.previous_accepted_vendor == localStorage.getItem('email')
              )
            return condition1 || condition2 || condition3 || condition4

          });
        } else {
          filterData = filterData.filter(item => item.indent_rejected_by_vendor === 1 && item.rejected != 1 && item.indentcancelledbyadmin !== 1);
        }
      }
      this.setState({ allindents: filterData, loadshow: "show-n", overlay: 'show-n' });
      if (this.state.selectedTab === 'Active Indents') {
        this.onClickchildTab(this.state.selectedChildTab);
      }
    });
  };
  resetindent = async () => {
    await this.fetchInitialData();
    const { rfqform, originalindents, selectedindent } = this.state;
    let awardeddata = [];

    if (rfqform.awarded === 'activet1') {
      if (localStorage.getItem('user_type') === 'TRANSPORTER') {
        awardeddata = originalindents.filter(e => e.accepted_vendor === localStorage.getItem('email') && e.vehicle_placement_expiried != 1 && e.rejected != 1);
        awardeddata = awardeddata.filter(e => {
          if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
            const vendorquote = e.vendorquotes.find(quote =>
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.indent_rejected_by_vendor != 1 &&
              quote.indent_accepted_by_vendor === 1
            );
            return vendorquote !== undefined;
          }
          return false;
        });
      } else {
        awardeddata = originalindents.filter(e => e.indent_assigned == 1 && e.indent_rejected_by_vendor != 1 && e.vehicle_placement_expiried != 1 && e.indent_cancelled != 1);
      }
      this.setState({ loadshow: 'show-n', allindents: awardeddata, overlay: 'show-n' });
    }

    if (selectedindent.indent_id) {
      this.getbidhistory(selectedindent.indent_id);
      this.gethistorydata(selectedindent.indent_id)
      const params = { indent_id: selectedindent.indent_id };
      redirectURL.post('/consignments/getlr_data', params).then(resp => {
        if (resp && resp.data) {
          const data = resp.data;
          if (data !== '') {
            this.setState({ lr_no_data: data });
          }
        }
      });
    }
  };

  refreshindent = async () => {
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

    // First, set the date values in state
    await this.setState({
      selectedfromdate: oneWeekAgo,
      selectedenddate: today
    });

    // Then fetch the data (this will use updated dates)
    await this.fetchInitialData();

    const { rfqform, originalindents, selectedindent, selectedfromdate, selectedenddate } = this.state;
    let awardeddata = [];

    if (rfqform.awarded === 'activet1') {
      if (localStorage.getItem('user_type') === 'TRANSPORTER') {
        awardeddata = originalindents.filter(e =>
          e.accepted_vendor === localStorage.getItem('email') &&
          e.vehicle_placement_expiried != 1 &&
          e.rejected != 1
        );
        awardeddata = awardeddata.filter(e => {
          if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
            const vendorquote = e.vendorquotes.find(quote =>
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.indent_rejected_by_vendor != 1 &&
              quote.indent_accepted_by_vendor === 1
            );
            return vendorquote !== undefined;
          }
          return false;
        });
      } else {
        awardeddata = originalindents.filter(e =>
          e.indent_assigned == 1 &&
          e.indent_rejected_by_vendor != 1 &&
          e.vehicle_placement_expiried != 1 &&
          e.indent_cancelled != 1
        );
      }
      this.setState({ loadshow: 'show-n', allindents: awardeddata });
    }

    // Use selectedfromdate and selectedenddate here
    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      from_date: selectedfromdate,
      to_date: selectedenddate
    };

    if (selectedindent.indent_id) {
      this.getbidhistory(selectedindent.indent_id);
      const lrParams = { indent_id: selectedindent.indent_id };
      redirectURL.post('/consignments/getlr_data', lrParams).then(resp => {
        if (resp && resp.data && resp.data !== '') {
          this.setState({ lr_no_data: resp.data });
        }
      });
    }
  };

  acceptindentbyvendor = (indent) => {
    const params = {
      indent_id: indent.indent_id,
      accepted_vendor: indent.accepted_vendor
    };
    redirectURL.post('/consignments/acceptindentbyvendor', params).then((resp) => {
      this.setState({
        show1: true,
        basicType1: 'success',
        basicTitle1: `Indent ${indent.indent_id} is successfully accepted`,
        showBidDetailsSlider: false
      });
      // this.resetindent();
      emitDataReceived({})
    });
  };
  rejectindentbyvendor = (indent) => {
    this.setState({
      cancelModelOpen: true,
      selectedindentforvendor: indent
    });
  };

  onSubmitdataforrejection = () => {
    if (this.state.rejectionReasonbyvendor != '' && this.state.rejectionReasonbyvendor != undefined) {
      const { selectedindentforvendor, rejectionReasonbyvendor } = this.state;
      const params = {
        indent_id: selectedindentforvendor.indent_id,
        accepted_vendor: selectedindentforvendor.accepted_vendor,
        rejectionreason: rejectionReasonbyvendor,
        rejectedreason_vendorname: localStorage.getItem('firstname'),
        email: localStorage.getItem('email'),
        user_type: localStorage.getItem('user_type')
      };

      redirectURL.post('/consignments/rejectindentbyvendor', params).then((resp) => {
        this.setState({
          show1: true,
          basicType1: 'success',
          basicTitle1: 'You have successfully rejected the indent.',
          cancelModelOpen: false,
          showBidDetailsSlider: false
        });
        // this.resetindent();
        emitDataReceived({})
      });
    }
  };

  getbidhistory = async (indent_id) => {
    await redirectURL.post("/consignments/getBidHistory", { indent_id }).then(response => {
      this.setState({
        bidHistory: response.data.bid_history,
        negotiations: response.data.negotiations,
        negotiationsHistory: response.data.negotiationslogs
      });
    });
  };

  isBiddingWindowExpired = (biddingWindow, createDate) => {
    if (!biddingWindow || !biddingWindow.includes(':') || !createDate) {
      return true;
    }

    const [hours, minutes] = biddingWindow.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
      return true;
    }

    const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30');
    const biddingEndTime = new Date(localCreateDate);

    biddingEndTime.setHours(biddingEndTime.getHours() + hours);
    biddingEndTime.setMinutes(biddingEndTime.getMinutes() + minutes);

    const currentTime = new Date();

    return currentTime > biddingEndTime;
  };

  deletedraftindent = (e) => {
    let draft_id = e.data.indent_id
    // console.log(draft_id)
    if (window.confirm(`Are you sure you want to delete draft?`)) {
      const params = { 'draft_id': draft_id };
      redirectURL.post('/consignments/deletedraftindent', params).then((resp) => {
        this.setState({
          showsweetalert: true,
          basicType: 'success',
          basicTitle: `Draft has been deleted`
        });
        this.resetindent();
      }).catch((err) => {
        this.setState({
          showsweetalert: true,
          basicType: 'error',
          basicTitle: 'Failed to delete draft'
        });
      });
    }
  };
  onClickBidNow = async (e) => {
    const { originalindents } = this.state;

    this.setState(prevState => {
      if (prevState.isCardOpen === e.indent_id) {
        return { isCardOpen: '', selectedindent: {} };
      } else {
        this.getbidhistory(e.indent_id);
        return { isCardOpen: e.indent_id, selectedindent: e };
      }
    });

    const data = originalindents.filter(f => f.indent_id === e.indent_id);
    let destinations = [];
    let data1 = JSON.parse(data[0].destination);
    data1.forEach(g => {
      destinations.push({
        indent_id: e.indent_id,
        dealer_city: g.dealer_city,
        dealer_pincode: g.dealer_pincode,
        dealer_code: g.dealer_code,
        quantity: g.quantity
      });
    });

    const params1 = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem('email')
    };

    redirectURL.post('/consignments/getstroreddata', params1).then(resp => {
      const transit_data = resp.data;
      transit_data.forEach(transitRecord => {
        const destinationRecord = destinations.find(dest =>
          dest.indent_id === transitRecord.indent_id &&
          dest.dealer_city === transitRecord.dealer_city
        );
        if (destinationRecord) {
          destinationRecord.bid_price = transitRecord.bid_price;
          destinationRecord.transit_days = transitRecord.transit_days;
        }
      });

      this.setState({
        indent_for_approve_for_bid: destinations,
        indent_for_approve_for_bid1: destinations,
        inputTextValue: "",
        inputTextQuantity: ""
      });
    });

    const params2 = { indent_id: e.indent_id };
    redirectURL.post('/consignments/getlr_data', params2).then(resp => {
      const data = resp.data;
      if (data && data !== '') {
        this.setState({ lr_no_data: data });
      }
    });

    const params3 = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem('email')
    };
    redirectURL.post('/consignments/getstroreddata', params3).then(resp => {
      const data1 = resp.data;
      let destinations = [];
      data1.forEach(f => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: f.dealer_city,
          dealer_pincode: f.dealer_pincode,
          truck_no: f.truck_no,
          bid_price: f.bid_price,

          transit_days: f.transit_days,
          material: f.material
        });
      });
      this.setState({ indent_for_approve1: destinations });

      let indentfortruckdetails = [];
      data1.forEach(g => {
        indentfortruckdetails.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          truck_no: g.truck_no,
          lr_no: g.lr_no
        });
      });
      this.setState({ indentfortruckdetails });
    });
  };

  changeFileHandler = (e) => {
    const formData = new FormData();
    formData.append("fileUpload", e.target.files[0]);
    // You can add logic here for upload if needed
  };

  closeBulkUploadModal = () => {
    this.setState({
      bulkUploadModal: {
        overly: "show-n",
        bulkPrioritySlide: ""
      },
      overlay: "show-n"
    });
  };

  onClickHideall = () => {
    this.setState({
      loadshow: 'show-n',
      overlay: 'show-n',
      showBidDetailsSlider: false,
      showBidDetailsSlider1: false,

      modelForNotifications: false,
      showsliderforbid: false,
      vehicleDetailsModel: false
    });
  };
  onClickAcceptNegotiation = (indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by) => {
    const params = {
      indent_id,
      bid_price,
      no_of_deliveries,
      vendor_email_id,
      email: localStorage.getItem("email"),
      user_type: localStorage.getItem("user_type"),
      indent_created_by
    };

    redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
      const isSuccess = response.data.status === "success";
      this.setState({
        showsweetalert: true,
        basicType: isSuccess ? "success" : "danger",
        basicTitle: 'Negotiated value has been accepted successfully.'
      });

      if (isSuccess) {
        this.setState({
          isVendorInputOpen: "",
          isProposedInputOpen: "",
          showBidDetailsSlider: false
        });
        // this.resetindent();
        emitDataReceived({})

      }
    }).catch(error => {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "An error occurred while processing the request."
      });
    });
  };

  onShowdata = (indent_id) => {
    this.setState({ vehicleDetailsModel: true, overlay: 'show-m' });
    const params = {
      indent_id: indent_id,
      vendor_email_id: localStorage.getItem('email')
    };

    redirectURL.post('/consignments/getstroreddata', params).then(resp => {
      const data1 = resp.data;
      const destinations = data1.map(e => ({
        indent_id: indent_id,
        dealer_city: e.dealer_city,
        dealer_pincode: e.dealer_pincode,
        bid_price: e.bid_price,
        truck_no: e.truck_no,
        lr_no: e.lr_no
      }));
      this.setState({ indent_for_approve1: destinations });
    });
  };
  onCloseSlider = () => {
    this.setState({
      overlay: 'show-n',
      showsliderforbid: false,
      showBidDetailsSlider1: '',
      cardforadminbifurcation: false,
      vehicleDetailsModel: false
    })
  }
  onSubmitdataforadminbifurcation = () => {
    const { dataforadminbifur, adminbifurComment } = this.state;

    // Step 1: Validate comment


    // Step 2: Validate price match
    const negotiatedconfirmed_price = dataforadminbifur[0].negotiatedconfirmed_price;
    const totalBidPrice = dataforadminbifur.reduce((sum, item) => {
      return sum + (parseFloat(item.bid_price) || 0);
    }, 0);


    if (totalBidPrice != negotiatedconfirmed_price) {
      this.setState({
        show1: true,
        basicType1: "danger",
        basicTitle1: "Freight bifurcation price must equal bid price"
      });
      return;
    }

    // if (!adminbifurComment || adminbifurComment.trim() === '') {
    //   this.setState({
    //     show1: true,
    //     basicType1: "danger",
    //     basicTitle1: "Comments are required before submission."
    //   });
    //   return;
    // }

    const params1 = {
      indent_id: dataforadminbifur[0].indent_id,
      bid_price: negotiatedconfirmed_price,
      vendor_email_id: dataforadminbifur[0].vendor_email_id,
      email: localStorage.getItem("email"),
      user_type: localStorage.getItem("user_type"),
      indent_created_by: dataforadminbifur[0].indent_created_by,
      adminbifurComment: adminbifurComment
    };

    redirectURL.post("/consignments/AcceptQuotationwithadmin", params1).then(response => {
      const isSuccess = response.data.status === "success";
      if (isSuccess) {
        this.setState({
          isVendorInputOpen: "",
          isProposedInputOpen: "",
          showBidDetailsSlider: false,
          adminbifurComment: ''
        });
        emitDataReceived({})
      }
    }).catch(error => {
      this.setState({
        show1: true,
        basicType1: "danger",
        basicTitle1: "An error occurred while processing the request."
      });
    });

    redirectURL.post('/consignments/storeadminbifur', dataforadminbifur).then(resp => {
      this.setState({
        show1: true,
        basicType1: "success",
        basicTitle1: 'Vendor value has been accepted successfully',
        cardforadminbifurcation: false,
        showBidDetailsSlider: false,
        overlay: 'show-n',
        adminbifurComment: ''
      });
      this.resetindent();
    });

  };


  onClickAcceptQuotation = (indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by, indent, vendorValue) => {
    if (localStorage.getItem('rfq_role') == 'ADMIN') {
      this.setState({
        cardforadminbifurcation: true, overlay: 'show-m',
      });
      // const { originalindents } = this.state;
      // const data = originalindents.filter(f => f.indent_id === indent_id);

      let destinations = [];
      let data1 = JSON.parse(this.state.selectedIndentData.destination);

      data1.forEach(g => {
        destinations.push({
          indent_id: indent_id,
          dealer_city: g.dealer_city,
          dealer_state: g.dealer_state,
          negotiatedconfirmed_price: vendorValue,
          dealer_pincode: g.dealer_pincode,
          dealer_name: g.dealer_name,
          dealer_code: g.dealer_code,
          vendor_email_id: vendor_email_id,
          indent_created_by: indent_created_by,
          materials: g.materials.map(material => ({
            material_type: material.material_type === 'others' ? material.other_material_type : material.material_type,
            material_dimensions: `${material.material_length} x ${material.material_breath} x ${material.material_height}`,
            quantity: material.quantity
          })),
          quantity: g.quantity
        });
      });

      this.setState({ dataforadminbifur: destinations });
    }
  };

  onCloseModal = () => {
    this.setState({
      modelForAdditionalComments: false,
      modelForShowBids: false,
      modelForNotifications: false,
      modelForEditAssigned: false,
      vehicleDetailsModel: false,
      cardforadminbifurcation: false,
      adminbifurComment: '',
      rejectModelOpen: false,
      cancelModelOpen: false,
      declineModel: false,
      modelForNotifications: false,
      overly: 'show-n',
      overlay: 'show-n'
    });
  };
  getIndentStatus = (indent) => {
    const userEmail = localStorage.getItem("email");
    const username = localStorage.getItem("username");
    const userRole = localStorage.getItem("roles");
    const userType = localStorage.getItem("user_type");

    const vendorquotes = indent.vendorquotes || [];
    const userQuote = vendorquotes.find(q => q.vendor_email_id === userEmail);
    const hasQuoteFromUser = !!userQuote;

    const isBiddingExpired = this.isBiddingWindowExpired(indent.bidding_window, indent.create_date);
    const condition3 =
      (
        vendorquotes.some(qi => qi.vendor_email_id != userEmail) && indent.indent_rejected_by_vendor == 1

      )
    const userDeclined = indent.vendors_participation &&
      indent.vendors_participation.hasOwnProperty(username) &&
      indent.vendors_participation[username] === "declined";

    // 1. Draft
    if (indent.is_draft === 1) return "Draft";
    if (
      (userQuote && userQuote.indent_rejected_by_vendor === 1) ||
      indent.previous_accepted_vendor === userEmail ||
      userDeclined || condition3
    ) {
      return "Vendor Declined";
    }
    // 2. Cancelled by admin
    if (indent.indentcancelledbyadmin === 1 || indent.rejected == 1 || (userQuote && userQuote.vendor_rejected == 1)) return "Indent Rejected";

    // 3. Rejected
    if (
      indent.rejected === 1 ||
      indent.rejectedwithapproval1 === 1 ||
      indent.rejectedwithapproval2 === 1
    ) {
      if (userType === "TRANSPORTER" && hasQuoteFromUser && indent.previous_accepted_vendor != userEmail) return "Indent Rejected";
    }

    // 4. Vendor Rejected


    if (
      indent &&
      userQuote &&
      indent.truck_details_completed !== 1 &&
      (userQuote.indent_accepted_by_vendor === 1 || userQuote.bid_winner === 1)
    ) {
      return 'Awaiting Truck Details';
    }

    // 5. Awarded
    if (
      indent.accepted_vendor === userEmail &&
      indent.vehicle_placement_expiried !== 1 &&
      indent.rejected !== 1 &&
      indent.validity_end !== 1 &&
      userQuote &&
      userQuote.indent_rejected_by_vendor !== 1 &&
      (userQuote.indent_accepted_by_vendor === 1 || userQuote.bid_winner === 1 && indent.truck_details_completed == 1)
    ) {
      return "Indent Awarded";
    }

    // 6. Awaiting Approval
    if (
      userQuote &&
      userQuote.negotiation_closed === 1 &&
      userQuote.bid_winner !== 1
    ) {
      return "Awaiting Approval";
    }
    if (
      indent.validity_end === 1 ||
      indent.vehicle_placement_expiried === 1 ||
      (
        isBiddingExpired &&
        !vendorquotes.some(q => q.vendor_email_id === userEmail) &&
        !userDeclined &&
        indent.validity_end !== 1 &&
        indent.vehicle_placement_expiried !== 1
      )
    ) {
      return "Expired";
    }
    // 7. Negotiation In Progress
    if (
      (userQuote && userQuote.pending_vendor_approval === 1) ||
      indent.pending_vendor_approval === 1 ||
      (userQuote && userQuote.in_negotiation === 1)
    ) {
      return "Negotiation In Progress";
    }

    // 8. Expired
    if (
      indent.validity_end === 1 ||
      indent.vehicle_placement_expiried === 1 ||
      (
        isBiddingExpired &&
        !vendorquotes.some(q => q.vendor_email_id === userEmail) &&
        !userDeclined &&
        indent.validity_end !== 1 &&
        indent.vehicle_placement_expiried !== 1
      )
    ) {
      return "Expired";
    }

    // 9. Bidding In Progress (default)
    return "Bidding In Progress";
  };
  fetchNotificationsData = (e) => {
    let indent_id = e.data.indent_id
    const params = {
      email: localStorage.getItem("email"),
      indent_id: indent_id
    };

    redirectURL.post("/consignments/fetchNotificationsData", params).then(response => {
      this.setState({
        notificationUnread: response.data.Unreadnotifications,
        notificationRead: response.data.Readnotifications,
        modelForNotifications: true,
        overlay: 'show-m',
        overly: 'show-m',
        selectedindentfornofication: indent_id
      });

      const { allindents } = this.state;
      const updatedIndents = allindents.map(indent => {
        if (indent.indent_id === indent_id) {
          return { ...indent, notification_count: 0 };
        }
        return indent;
      });

      this.setState({ allindents: updatedIndents });
    });
  };


  handlerStartDateTime = (event, currentDate, selectedDate) => {
    const d = new Date(event._d);
    const startdate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate());
    this.setState({ selectedfromdate: startdate });
  };

  handlerEndDateTime = (event, currentDate, selectedDate) => {
    const d = new Date(event._d);
    const startdate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate());
    this.setState({ selectedenddate: startdate });
  };

  handleSelectChange = (name, selectedOption) => {
    const { searchfilter } = this.state;
    this.setState({
      searchfilter: {
        ...searchfilter,
        [name]: selectedOption ? selectedOption.value : null
      }
    });
  };

  resetSearchFilter = () => {
    const { rfqform, originalindents, alldata } = this.state;
    const updatedRfqForm = {
      ...rfqform,
      cancelled: '',
      total: 'activet1',
      active: '',
      completed: '',
      awarded: '',
      rejected: '',
      Delivered: '',
      vendorrejected: '',
      vehicle_placement_missed: '',
      drafts: ''
    };

    let filteredIndents = alldata;

    if (rfqform.active === 'activet') {
      filteredIndents = originalindents.filter(e => e.indent_expired != 1);
    } else if (rfqform.cancelled === 'activet') {
      filteredIndents = originalindents.filter(e => e.indent_expired == 1);
    }

    this.setState({
      rfqform: updatedRfqForm,
      allindents: filteredIndents,
      originalindents: alldata,
      searchfilter: {}
    });

    this.getcountersforindents(alldata, []);
  };

  getStatusFromIndent = (indent) => {
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      return this.getIndentStatus(indent);
    }

    switch (true) {
      case indent.rejected === 1:
      case indent.indentcancelledbyadmin === 1:
        return 'Indent Rejected';
      case indent.vehicle_placement_expiried === 1:
      case indent.validity_end === 1 && indent.indent_assigned != 1 || (
        indent.bidding_window &&
        indent.create_date &&
        this.isBiddingWindowExpired(indent.bidding_window, indent.create_date) &&
        indent.vendorquotes &&
        indent.vendorquotes.length === 0 && indent.indent_assigned != 1
      ):
        return 'Expired';

      case indent.is_draft === 1:
        return 'Draft';
      case indent.truck_details_completed === 1:
        return 'Vehicle Placed';
      case indent.indent_rejected_by_vendor === 1:
        return 'Award Declined';
      case indent.waiting_for_approval1 === 1 && indent.changed_l2_as_l1 == 1:
        return 'Awaiting Approval to Consider L2 as L1';
      case indent.waiting_for_approval1 === 1 && indent.started_truck_details != 1 && indent.indent_accepted_by_vendor != 1:
        return 'Awaiting Approval';
      case indent.vendorquotes && indent.vendorquotes.some(e => e.in_negotiation === 1) && indent.started_truck_details != 1 && indent.indent_assigned != 1:
        return 'Negotiation In Progress';
      case indent.approved_changed_l2_as_l1 === 1:
        return 'Negotiation In Progress';
      case indent.vendorquotes && indent.vendorquotes.some(e => e.vendor_email_id == indent.accepted_vendor && e.indent_accepted_by_vendor == 1) && indent.truck_details_completed != 1:
        return 'Awaiting Truck Details'
      case indent.approvedwithapproval2 === 1:
        return 'Indent Awarded';

      case indent.vendorquotes && indent.vendorquotes.length === 0:
        return 'Bidding In Progress';
      case indent.quantity === indent.confirmed_quantity || indent.indent_assigned === 1:
        return 'Indent Awarded';
      default:
        return 'Bidding In Progress';
    }
  };

  getindents = (e) => {
    e.preventDefault();
    const { alldata, searchfilter } = this.state;

    const filteredIndents = alldata.filter((item) => {
      return Object.entries(searchfilter).every(([key, value]) => {
        if (value === '') return true;

        if (key === 'status') {
          const currentStatus = this.getStatusFromIndent(item);
          return currentStatus.toLowerCase() === value.toLowerCase();
        }

        if (item[key] && typeof item[key] === 'string' && typeof value === 'string') {
          return item[key].toLowerCase() === value.toLowerCase();
        } else {
          return item[key] == value;
        }
      });
    });

    this.setState({
      allindents: filteredIndents,
      originalindents: filteredIndents
    });
    this.getcountersforindents(filteredIndents, []);
  };

  handleInputChangeforaccept = (index, field, value) => {
    const updatedDestinations = [...this.state.indent_for_approve];
    updatedDestinations[index][field] = value;
    this.setState({ indent_for_approve: updatedDestinations });
  };

  handleInputChangeforacceptfortruck = (index, field, value) => {
    const updatedDestinations = [...this.state.indentfortruckdetails];
    updatedDestinations[index][field] = value;
    this.setState({ indentfortruckdetails: updatedDestinations });
  };

  handleInputChangeforacceptfortruck1 = (index, field, value) => {
    const updatedDestinations = [...this.state.lr_no_data];
    updatedDestinations[index][field] = value;
    this.setState({ lr_no_data: updatedDestinations });
  };

  handleInputChangeforadmin_bifur = (index, field, value) => {
    const updatedDestinations = [...this.state.dataforadminbifur];
    updatedDestinations[index][field] = value;
    this.setState({ dataforadminbifur: updatedDestinations });
  };

  onSubmitdata = () => {
    const { indent_for_approve, selecteddata } = this.state;
    const hasInvalidFields = indent_for_approve.some(destination => !destination.bid_price || !destination.transit_days);

    if (hasInvalidFields) {
      alert("Please fill in all Bid Price and Transit Days fields before submitting.");
      return;
    }

    const submissionData = indent_for_approve.map(destination => ({
      indent_id: destination.indent_id,
      dealer_city: destination.dealer_city,
      dealer_pincode: destination.dealer_pincode,
      bid_price: destination.bid_price,
      transit_days: destination.transit_days,
      material: destination.material,
      vendor_email_id: localStorage.getItem('email'),
      vendor_name: localStorage.getItem('firstname')
    }));

    const params1 = { submissionData };
    redirectURL.post('/consignments/storedata', params1);

    const { indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by } = selecteddata;
    const params = {
      indent_id,
      bid_price,
      no_of_deliveries,
      vendor_email_id,
      email: localStorage.getItem("email"),
      user_type: localStorage.getItem("user_type"),
      indent_created_by
    };

    redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
      const isSuccess = response.data.status === "success";
      this.setState({
        showsweetalert: true,
        basicType: isSuccess ? "success" : "danger",
        basicTitle: response.data.message,
      });

      if (isSuccess) {
        this.setState({
          isVendorInputOpen: "",
          isProposedInputOpen: ""
        });
      }
    }).catch(error => {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "An error occurred while processing the request."
      });
    });
  };

  onshowPreview = (e) => {
    const destinationDetails = JSON.parse(e.destination || '[]');
    this.setState({
      isPreviewMode: true,
      rfqform: e,
      dealers: destinationDetails
    });
  };
  onCancel = (e) => {
    this.setState({
      cardforadminbifurcation: false,
      overlay: 'show-n'
    })
  }
  onSubmitdata1 = (e) => {
    const { lr_no_data, indentfortruckdetails } = this.state;
    let submissionData = [];

    if (e.started_truck_details === 1) {
      submissionData = lr_no_data.map(destination => ({
        indent_id: destination.indent_id,
        dealer_city: destination.dealer_city,
        dealer_pincode: destination.dealer_pincode,
        truck_no: destination.truck_no,
        bid_price: destination.bid_price,
        lr_no: destination.lr_no || null
      }));
    } else {
      submissionData = indentfortruckdetails.map(destination => ({
        indent_id: destination.indent_id,
        dealer_city: destination.dealer_city,
        dealer_pincode: destination.dealer_pincode,
        truck_no: destination.truck_no,
        bid_price: destination.bid_price,
        lr_no: destination.lr_no || null,
        submitted: 1,
        started_truck_details: 1
      }));
    }

    const params1 = { submissionData };
    redirectURL.post('/consignments/storetruckdetails', params1).then(resp => {
      this.setState({
        showsweetalert: true,
        basicType: "success",
        basicTitle: 'Truck details updated successfully',
        vehicleDetailsModel: false,
        showBidDetailsSlider1: false
      });
      this.resetindent();
    });
  };

  handleInputChange = (e) => {
    this.setState({ selected_transit_days: e });
  };

  handleInputChange1 = (e) => {
    this.setState({ selected_bid_price: e });
  };
  handleBidPriceChange = (value) => {
    this.setState({ selected_bid_price: value });
  };

  handleTransitDaysChange = (value) => {
    this.setState({ selected_transit_days: value });
  };
  onSubmitquote = (e) => {
    e.preventDefault();
    const {
      selected_bid_price,
      selected_transit_days,
      selectedindent,
      indent_for_approve_for_bid
    } = this.state;

    const params = {
      bid_price: selected_bid_price,
      transit_time: selected_transit_days,
      email: localStorage.getItem('email'),
      indent_id: selectedindent.indent_id,
      username: localStorage.getItem('user_name')
    };

    this.setState({ loadshow: 'show-m', overlay: 'show-m' });
    redirectURL.post('/consignments/storeaccepflag', { 'indent_id': selectedindent.indent_id, 'vendor_name': localStorage.getItem('username'), 'vendor_email_id': localStorage.getItem('email') }).then((resp) => {
      // this.setState({
      //   show: true,
      //   basicType: 'success',
      //   basicTitle: 'Successfully Accepted',
      //   rejectModelOpen: false
      // });
      // this.resetindent()

    })
    redirectURL.post('consignments/submitQuote', params).then(response => {
      if (response.data.status === 'success') {
        this.setState({
          loadshow: 'show-n',
          overlay: 'show-n',
          isCardOpen: "",
          showsweetalert: true,
          basicType: "success",
          basicTitle: 'Your Bid has been successfully placed',
          selected_bid_price: "",
          selected_transit_days: "",
          showsliderforbid: false,
        });

        this.resetindent();
      }
    });

    const submissionData = indent_for_approve_for_bid.map(destination => ({
      indent_id: selectedindent.indent_id,
      dealer_city: destination.dealer_city,
      dealer_pincode: destination.dealer_pincode,
      bid_price: destination.bid_price,
      transit_days: destination.transit_days,
      material: destination.material,
      vendor_email_id: localStorage.getItem('email'),
      vendor_name: localStorage.getItem('firstname')
    }));

    const params3 = { submissionData, indent_id: selectedindent.indent_id };
    redirectURL.post('/consignments/updatebidprice', params3);

    const params1 = { submissionData };
    redirectURL.post('/consignments/storedata', params1);
  };

  closeAlert = () => {
    this.setState({ showsweetalert: false, open: false });
    // window.location.href = "/indentsummary"
    if (["success"].includes(this.state.basicType)) {
      // window.location.href = "/indentsummary"
      this.getInitialDataForBidDetailsScreen()
    }

  };
  closeAlert1 = () => {
    this.setState({ show1: false, open1: false });
    if (["success"].includes(this.state.basicType1)) {
      // window.location.href = "/indentsummary"
      this.getInitialDataForBidDetailsScreen()
    }

  };

  onIconHover = (rowId) => {
    this.setState({ hoveredIconId: rowId });
  };
  onClickViewPOD = (e) => {
    let indent = e.data.indent
    const params = { pod_document: indent.upload_for_road };
    redirectURL.post("/billing/downloadfileforroad", params, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("userid")
      }
    }).then(res => {
      const downloadUrl = decodeURIComponent(res.data.url);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", e || "");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(error => {
      // Handle error silently
    });
  };

  onClickcreateindent = () => {
    this.setState({ redirect: true });
  };
  tabNames = localStorage.getItem('user_type') === 'TRANSPORTER'
    ? {
      Active: "Active Indents",
      Awarded: "Awarded Indents",
      Delivered: "Delivered Indents",
      vendorrejected: "Vendor Declined Indents",
      Drafts: "Draft Indents",
      rejected: "Rejected Indents",
      Completed: "Expired Indents",
      total: "All Indents"
    }
    : {
      Active: "Active Indents",
      Awarded: "Awarded Indents",
      Delivered: "Delivered Indents",
      vendorrejected: "Award Declined Indents",
      Drafts: "Draft Indents",
      rejected: "Rejected Indents",
      Completed: "Expired Indents",
      total: "All Indents"
    };
  onClickparentTab = (e) => {
    const current_date = new Date();
    const tabLabel = this.tabNames[e] || e;
    this.setState({ selectedTab: tabLabel, selectedTabforparent: tabLabel });
    let data = [];

    const userType = localStorage.getItem('user_type');
    const userEmail = localStorage.getItem('email');

    const setRfqFormField = (field) => {
      this.setState(prev => ({
        rfqform: {
          ...prev.rfqform,
          cancelled: '',
          total: '',
          active: '',
          completed: '',
          awarded: '',
          rejected: '',
          Delivered: '',
          vendorrejected: '',
          vehicle_placement_missed: '',
          drafts: '',
          [field]: 'activet1'
        }
      }));
    };

    if (e === 'total') {
      setRfqFormField('total');
      data = userType === 'TRANSPORTER'
        ? this.state.originalindents.filter(item => item.vendordetails.some(vendor => vendor.email === userEmail))
        : [...this.state.originalindents, ...this.state.draftdata];
    }
    // else if (e === 'Expired') {
    //   this.setRfqFormField('cancelled');

    //   if (localStorage.getItem('roles') == 'AL_ADMIN') {
    //     data = this.state.originalindents.filter(
    //       item =>
    //         this.isBiddingWindowExpired(item.bidding_window, item.create_date) &&
    //         item.vendorquotes.length === 0
    //     );
    //   } else {
    //     data = this.state.originalindents.filter(
    //       item => item.vehicle_placement_expiried === 1
    //     );
    //   }
    // }

    else if (e === 'Delivered') {
      setRfqFormField('Delivered');
      data = this.state.originalindents.filter(item => item.allDelivered === 1);
    }
    else if (e === 'Awarded') {
      setRfqFormField('awarded');
      if (userType === 'TRANSPORTER') {
        data = this.state.originalindents.filter(item =>
          item.accepted_vendor === userEmail &&
          item.vehicle_placement_expiried !== 1 &&
          item.rejected !== 1 &&
          item.validity_end !== 1
        ).filter(item => {
          const q = item.vendorquotes || [];
          const vendorquote = q.find(quote =>
            (quote.vendor_email_id === userEmail &&
              quote.indent_rejected_by_vendor !== 1 &&
              quote.indent_accepted_by_vendor === 1) ||
            quote.bid_winner === 1
          );
          return vendorquote !== undefined;
        });
      } else {
        data = this.state.originalindents.filter(item =>
          item.indent_assigned === 1 &&
          item.indent_rejected_by_vendor !== 1 &&
          item.vehicle_placement_expiried !== 1 &&
          item.indent_cancelled !== 1 && item.rejected != 1
        );
      }
    }
    else if (e === 'Active') {
      setRfqFormField('active');
      if (userType === 'TRANSPORTER') {
        data = this.state.originalindents.filter(item => {
          const q = item.vendorquotes || [];
          const validDetails = item.vendordetails && item.vendordetails.length > 0 && item.indent_assigned !== 1 && item.validity_end !== 1 && item.approvedwithapproval2 !== 1 && item.rejected !== 1;
          const pendingDifferent = item.indent_pending_data && item.indent_pending_data.vendor_email_id !== userEmail;
          const differentVendorWithQuotes = item.previous_accepted_vendor !== userEmail && q.some(f => f.vendor_email_id === userEmail) && q.find(g => g.bid_winner !== 1);
          const expiredWithoutQuote = this.isBiddingWindowExpired(item.bidding_window, item.create_date) && (!q || !q.some(x => x.vendor_email_id === userEmail));
          return (validDetails || pendingDifferent || differentVendorWithQuotes) && !expiredWithoutQuote;
        }).filter(item =>
          item.previous_accepted_vendor !== userEmail &&
          item.indentcancelledbyadmin !== 1 &&
          item.indent_cancelled !== 1 &&
          item.approvedwithapproval2 !== 1 &&
          item.rejected !== 1 &&
          item.vendors_participation &&
          item.vendors_participation.hasOwnProperty(localStorage.getItem('username')) &&
          item.vendors_participation[localStorage.getItem('username')] !== 'declined'
        ).filter(item => {
          const q = item.vendorquotes || [];
          if (q.length && q.some(quote => quote.vendor_email_id === userEmail)) {
            const vendorquote = q.find(quote => quote.vendor_email_id === userEmail && quote.vendor_rejected !== 1 && quote.indent_rejected_by_vendor !== 1);
            return vendorquote !== undefined;
          }
          return true;
        }).filter(item => {
          const q = item.vendorquotes || [];
          if (q.length && q.some(quote => quote.vendor_email_id === userEmail)) {
            const vendorquote = q.find(quote => quote.vendor_email_id === userEmail && quote.indent_rejected_by_vendor !== 1 && quote.indent_accepted_by_vendor !== 1 && quote.vendor_rejected !== 1 && item.approvedwithapproval2 !== 1 && item.validity_end !== 1);
            return vendorquote !== undefined;
          }
          return true;
        });
      } else {
        data = this.state.originalindents.filter(item =>
          item.vendordetails &&
          item.vendordetails.length > 0 &&
          item.indent_assigned !== 1 &&
          item.validity_end !== 1 &&
          item.rejected !== 1 &&
          item.indentcancelledbyadmin !== 1 &&
          (
            item.vendorquotes.length > 0 ||
            !this.isBiddingWindowExpired(item.bidding_window, item.create_date)
          )
        );
      }

    }
    else if (e === 'Completed') {
      setRfqFormField('completed');

      if (localStorage.getItem('rfq_role') == 'ADMIN') {
        data = this.state.originalindents.filter(e => e.rejected != 1 && e.indent_assigned != 1)
        data = data.filter(
          item =>
            (this.isBiddingWindowExpired(item.bidding_window, item.create_date) && item.rejected != 1 &&
              item.vendorquotes.length === 0) || (item.validity_end === 1 || item.vehicle_placement_expiried === 1)
        );
      }
      else {
        const username = localStorage.getItem('username');
        const userEmail = localStorage.getItem('email');

        data = this.state.originalindents.filter(item => {
          const vendorQuotes = item.vendorquotes || [];

          const isExpired =
            item.validity_end === 1 ||
            item.vehicle_placement_expiried === 1 ||
            this.isBiddingWindowExpired(item.bidding_window, item.create_date);

          const notQuoted = !vendorQuotes.some(x => x.vendor_email_id === userEmail && x.negotiation_closed != 1);

          const declinedByCurrentUser =
            item.vendors_participation &&
            item.vendors_participation.hasOwnProperty(username) &&
            item.vendors_participation[username] === 'declined';

          return (isExpired) && !declinedByCurrentUser && item.rejected != 1 && item.indent_assigned != 1 && item.waiting_for_approval1 != 1;;
        });

      }


    }
    else if (e === 'rejected') {
      setRfqFormField('rejected');
      if (userType === 'TRANSPORTER') {
        data = this.state.originalindents.filter(e => e.previous_accepted_vendor != localStorage.getItem('email'))
        data = data.filter(item => {
          const q = item.vendorquotes || [];
          const isRejected = item.rejected === 1 && q.some(qi => qi.vendor_email_id === userEmail) && item.previous_accepted_vendor != localStorage.getItem('email')
          const match = q.find(quote => quote.vendor_email_id === userEmail && quote.bid_winner === 0 && quote.pending_vendor_approval == 1 && e.approvedwithapproval2 == 1
            && item.accepted_vendor !== userEmail)
          return isRejected || match !== undefined;
        });
      } else {
        data = this.state.originalindents.filter(item => item.rejected === 1 || item.rejectedwithapproval1 === 1);
      }
    }
    else if (e === 'vendorrejected') {
      setRfqFormField('vendorrejected');
      if (userType === 'TRANSPORTER') {
        data = this.state.originalindents.filter(item => {
          const q = item.vendorquotes || [];
          // current user
          const username = localStorage.getItem('username');

          // true when this user is marked "declined" on the item
          const declinedByCurrentUser =
            item.vendors_participation &&
            item.vendors_participation.hasOwnProperty(username) &&
            item.vendors_participation[username] === 'declined';

          /* ─────────────────────────  CONDITIONS  ───────────────────────── */

          const condition1 =
            (
              q.find(
                quote =>
                  quote.vendor_email_id === userEmail &&
                  quote.indent_rejected_by_vendor === 1
              ) &&
              item.validity_end !== 1 &&
              item.vehicle_placement_expiried !== 1 &&
              item.rejectedwithapproval2 !== 1
            ) ||
            declinedByCurrentUser;

          const condition2 =
            (
              item.previous_accepted_vendor === userEmail &&
              item.validity_end !== 1 &&
              item.vehicle_placement_expiried !== 1 &&
              item.rejectedwithapproval2 !== 1
            ) ||
            declinedByCurrentUser;

          const condition3 =
            (
              q.some(qi => qi.vendor_email_id != userEmail) && item.indent_rejected_by_vendor == 1

            )
          const condition4 =
            (
              item.previous_accepted_vendor == localStorage.getItem('email')
            )
          return condition1 || condition2 || condition3 || condition4

        });
      } else {
        data = this.state.originalindents.filter(item => item.indent_rejected_by_vendor === 1 && item.rejected != 1 && item.indentcancelledbyadmin !== 1);
      }
    }
    else if (e === 'vehicle_placement_missed') {
      setRfqFormField('vehicle_placement_missed');
      data = this.state.originalindents.filter(item => item.indentcancelledbyadmin === 1);
    }
    else if (e === 'Drafts') {
      setRfqFormField('drafts');
      data = this.state.draftdata;
    }

    this.setState({ allindents: data });
    if (e === 'Active') {
      this.onClickchildTab('Bidding In Progress');
    }
  };

  isNegotiationWindowExpired = (biddingWindow, negotiationWindow, createDate) => {
    if (
      !biddingWindow || !biddingWindow.includes(':') ||
      !negotiationWindow || !negotiationWindow.includes(':') ||
      !createDate
    ) {
      return true;
    }

    const parseWindow = (win) => {
      const [h, m] = win.split(':').map(Number);
      return [h || 0, m || 0];
    };

    const [bH, bM] = parseWindow(biddingWindow);
    const [nH, nM] = parseWindow(negotiationWindow);

    if (isNaN(bH) || isNaN(bM) || isNaN(nH) || isNaN(nM)) {
      return true;
    }

    // base create date
    const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30');

    // bidding end
    const biddingEndTime = new Date(localCreateDate);
    biddingEndTime.setHours(biddingEndTime.getHours() + bH);
    biddingEndTime.setMinutes(biddingEndTime.getMinutes() + bM);

    // negotiation end (starts after bidding ends)
    const negotiationEndTime = new Date(biddingEndTime);
    negotiationEndTime.setHours(negotiationEndTime.getHours() + nH);
    negotiationEndTime.setMinutes(negotiationEndTime.getMinutes() + nM);

    const currentTime = new Date();

    return currentTime > negotiationEndTime;
  };

  onClickchildTab = (selectedChildTab) => {
    this.setState({ selectedChildTab });
    this.setState({ selectedSubTab: selectedChildTab });
    this.setState({ selectedTabforparent: `Active Indents - ${selectedChildTab}` });
    const activedata = this.state.originalindents.filter(
      item =>
        item.vendordetails &&
        item.vendordetails.length > 0 &&
        item.indent_assigned !== 1 &&
        item.validity_end !== 1 &&
        item.rejected !== 1 &&
        item.indentcancelledbyadmin !== 1 &&
        (
          item.vendorquotes.length > 0 ||
          !this.isBiddingWindowExpired(item.bidding_window, item.create_date)
        )
    );
    const bidding_in_progress_data = activedata.filter(
      indent => {
        const status = this.getStatusFromIndent(indent);
        return status === 'Negotiation In Progress' || status === 'In Progress';
      }
    );

    const waiting_for_approval_data = activedata.filter(indent =>
      this.getStatusFromIndent(indent) === 'Awaiting Approval' ||
      this.getStatusFromIndent(indent) === 'Awaiting Approval to Consider L2 as L1'
    );

    const waiting_for_quote_data = activedata.filter(
      indent => this.getStatusFromIndent(indent) === 'Bidding In Progress'
    );

    let filteredChildData = [];

    switch (selectedChildTab) {
      case 'Negotiation In Progress':
        filteredChildData = bidding_in_progress_data;
        break;

      case 'Awaiting Approval':
        filteredChildData = waiting_for_approval_data;
        break;
      case 'Awaiting Approval to Consider L2 as L1':
        filteredChildData = waiting_for_approval_data;
        break;

      case 'Bidding In Progress':
        filteredChildData = waiting_for_quote_data;
        break;

      default:
        filteredChildData = [];
        break;
    }

    this.setState({
      subcountertab: {
        bidding_in_progress_data: bidding_in_progress_data,
        waiting_for_approval_data: waiting_for_approval_data,
        waiting_for_quote_data: waiting_for_quote_data
      },
      filteredChildData: filteredChildData,
      allindents: filteredChildData
    });
  };




  toggleShowAllRecords = () => {
    this.setState((prevState) => ({ showAllRecords: !prevState.showAllRecords }));
  };

  onClickcancelindent = (indent, bid) => {
    const params = { indent, bid };
    redirectURL.post('/consignments/cancelindent', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'Indent cancelled successfully'
      });
      this.resetindent();
    });
  };


  onClickchangerankbtn = (indent) => {
    let bid = indent.vendorquotes
    const params = { indent, bid };
    redirectURL.post('/consignments/changerankforvendorrejection', params).then((resp) => {
      this.setState({
        show1: true,
        basicType1: 'success',
        basicTitle1: 'Successfully changed L2 as L1',
        showBidDetailsSlider: false

      });
      // this.resetindent();
      emitDataReceived({})
    });
  };
  render() {

    // localStorage.setItem("indent_id", this.state.selectedIndentData.indent_id)

    const modalStyles1 = {
      width: '300px !important'
    };
    const { selectedIndentData, selectedVendorQuotes, negotiations, negotiationsLogs, rfqform ,proposedValues} = this.state;
    var indent = this.state.selectedIndentData
    const isNegotiationExpired = this.isNegotiationWindowExpired(
      indent.bidding_window,
      indent.negotiation_window,
      indent.create_date
    );

    const hasNegotiationBegin = proposedValues && Object.keys(proposedValues).length > 0;

    const disableAcceptInNegotiation = hasNegotiationBegin && !isNegotiationExpired
    return (
      <>
        <SweetAlert
          show={this.state.showsweetalert}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnCssClass={`btn btn-${this.state.basicType}`}
          onConfirm={this.closeAlert}

        />
        <SweetAlert
          show={this.state.show1}
          type={this.state.basicType1}
          title={this.state.basicTitle1}
          confirmBtnCssClass={`btn btn-${this.state.basicType1}`}
          onConfirm={this.closeAlert1}

        />

        {localStorage.getItem('rfq_role') == 'ADMIN' ?
          <>
            <div
              className="d-flex justify-content-between align-items-center"

            >
              <h5 className="heading-18-600" >
                <span className="custom-link" onClick={() => {
                  // localStorage.removeItem("indent_id")
                  this.props.history.push("/indentsummary")
                }
                }>
                  <i className="icofont icofont-home"></i>
                </span>
                <span> / {this.state.selectedIndentData.indent_id} / Bid Details</span>
              </h5>

              {/* Back Arrow + Back Text */}
              <div className="back-btn d-flex align-items-center back-link-btn" style={{cursor:"pointer"}} onClick={() => {
                // localStorage.removeItem("indent_id")
                this.props.history.push("/indentsummary")
              }
              }>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M15 8a.5.5 0 0 1-.5.5H3.707l3.147 
        3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 
        0 0 1 0-.708l4-4a.5.5 0 1 1 
        .708.708L3.707 7.5H14.5A.5.5 
        0 0 1 15 8z"
                  />
                </svg>
                <span className="ml-5p">Back</span>
              </div>
            </div>



            <div>
              <div className="slider-wrapper">
                <div className="slider-section p-3">
                  <div className="info-row1">
                    <div className="label6">Indent ID </div>
                    <div>{this.state.selectedIndentData.indent_id}</div>
                  </div>
                  <div className="info-row1">
                    <div className="label6">Source </div>
                    <div>{this.state.selectedIndentData.source}</div>
                  </div>
                  <div className="info-row1">
                    <div className="label6">Destination(s) </div>
                    <div>
                      {JSON.parse(this.state.selectedIndentData.destination || "[]").map((d, i) => (
                        <span key={i} className="destination-pill">
                          {d.dealer_city.charAt(0).toUpperCase() + d.dealer_city.slice(1).toLowerCase()}
                        </span>
                      ))}
                    </div>

                  </div>
                  <div className="info-row1">
                    <div className="label6">Distance </div>
                    <div>{this.state.selectedIndentData.total_km} KM</div>
                  </div>
                  {localStorage.getItem('rfq_role') == 'ADMIN' ? <div className="info-row1">
                    <div className="label6">Participants </div>
                    <div>
                      {this.state.selectedVendorQuotes.length} /{" "}
                      {this.state.selectedIndentData.vendors_names ? JSON.parse(this.state.selectedIndentData.vendors_names).length : 0}
                    </div>
                  </div> : ''}
                  <div className="info-row1">
                    <div className="label6">Truck Type </div>
                    <div>{this.state.selectedIndentData.type_of_truck}</div>
                  </div>
                  {this.state.selectedIndentData && this.state.selectedIndentData.base_price != '' ?
                    <div className="info-row1">
                      <div className="label6">Base Price </div>
                      <div>{this.state.selectedIndentData.base_price}</div>
                    </div> : ''}

                  {/* <div className="info-row1">
          <div className="label6">Truck Type :</div>
          <div>{this.state.selectedIndentData.type_of_truck}</div>
        </div> */}
                  <div className="info-row1">
                    <div className="label6">Status </div>
                    <div className="status-badge">
                      {this.state.selectedIndentData.status}
                    </div>
                  </div>
                  {/* {this.state.selectedIndentData && this.state.selectedIndentData.approvedwithapproval2 == 1 ? <div className="info-row1">
                    <div className="label6">Best Quote</div>
                    <div>{this.state.selectedIndentData.confirmed_value}</div>
                  </div> : ''} */}
                  {this.state.selectedIndentData && this.state.selectedIndentData.rejected_reason_by_approval1 != '' && this.state.selectedIndentData.rejected_reason_by_approval1 != undefined ?
                    <div className="info-row1">
                      <div className="label6">Reason</div>
                      <div>{this.state.selectedIndentData.rejected_reason_by_approval1}</div>
                    </div> : ''}

                  {localStorage.getItem('rfq_role') == 'ADMIN' && <div className="info-row1">
                    <div className="label6">Recommendations</div>
                    <div>Best Value : {this.state.leastValue} , Avg Value : {this.state.avgValue}</div>
                  </div>}

                  {localStorage.getItem('rfq_role') == 'ADMIN' && <div className="info-row1">
                    <div className="label6">Negotiation Cutoff (HH:mm)</div>
                    <div>{<span style={{ fontSize: '13px', fontWeight: 500 }}>
                      <NegotiationCutoffTimer
                        biddingWindow={this.state.selectedIndentData.bidding_window}
                        negotiationWindow={this.state.selectedIndentData.negotiation_window}
                        createDate={this.state.selectedIndentData.create_date}
                        indent_id={this.state.selectedIndentData.indent_id}
                        vendorquotes={this.state.selectedIndentData.vendorquotes}
                        negotiation_timer_ends={this.state.selectedIndentData.negotiation_timer_ends}
                      />

                    </span>}</div>
                  </div>}

                </div>
              </div>

              <section className="section-wrapper">
                <table className="dealer-table">
                  <thead>
                    <tr className="dealer-table-header">
                      <th rowSpan="2">Vendor</th>
                      <th rowSpan="2">Transit Days</th>
                      <th rowSpan="2" className='text-center'>Last Month Awd. Indents</th>
                      <th rowSpan="2">Bid Price (₹)</th>
                      <th colSpan="2" className="text-center">Proposed</th>
                      <th colSpan="2" className="text-center">Vendor Value</th>
                      <th rowSpan="2">History</th>
                      <th rowSpan="2">Action</th>
                    </tr>
                    <tr className="dealer-table-header">
                      <th>Amount (₹)</th>
                      <th>Transit Days</th>
                      <th>Amount (₹)</th>
                      <th>Transit Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.selectedVendorQuotes.map((vendor, idx) => {
                      const rank = "L" + (vendor.rank || idx + 1);
                      const matchedVendor = this.state.selectedIndentData.vendordetails.find(v =>
                        v.email === vendor.vendor_email_id || v.email_id === vendor.vendor_email_id
                      );
                      const awardedVendorEmail = this.state.selectedIndentData.accepted_vendor;
                      const isAwarded = awardedVendorEmail && awardedVendorEmail === vendor.vendor_email_id;

                      const vendorName = matchedVendor ? matchedVendor.source : '—';
                      const negotiation = this.state.negotiations.find(n => n.vendor_email_id === vendor.vendor_email_id) || {};
                      const vendorValue = negotiation.vendor_value || '—';
                      const vendorQuantity = negotiation.vendor_quantity || '—';
                      const proposedValue = negotiation.proposed_value || '';
                      const proposedQuantity = negotiation.proposed_quantity || '';
                      const forNegotiationAfterConsiderL2AsL1 = !(
                        this.state.selectedIndentData.rejected === 1 ||
                        this.state.selectedIndentData.validity_end == 1 ||
                        (vendor.bid_winner == 0 &&
                          vendor.pending_vendor_approval != 1 &&
                          this.state.selectedIndentData.truck_details_completed == 1) ||
                        vendor.in_negotiation === 0 ||
                        (
                          new Date() >
                          moment
                            .parseZone(new Date(this.state.selectedIndentData.bid_start_date))
                            .utcOffset("-05:30")
                            .add(parseInt(this.state.selectedIndentData.quotation_validity_hours), "hours")
                            ._d &&
                          this.state.selectedIndentData.quantity === this.state.selectedIndentData.confirmed_quantity
                        ) ||
                        [1].includes(vendor.pending_vendor_approval)
                      );
                      const isAcceptButtonVisible =
                        !(
                          this.state.selectedIndentData.rejected === 1 ||
                          this.state.selectedIndentData.validity_end == 1 ||
                          (vendor.bid_winner == 0 &&
                            vendor.pending_vendor_approval != 1 &&
                            this.state.selectedIndentData.truck_details_completed == 1) ||
                          this.state.selectedIndentData.negotiation_timer_ends == 1 ||   // ✅ DB flag
                          isNegotiationExpired ||                                        // ✅ Live check
                          vendor.in_negotiation === 0 ||
                          (
                            new Date() >
                            moment
                              .parseZone(new Date(this.state.selectedIndentData.bid_start_date))
                              .utcOffset("-05:30")
                              .add(parseInt(this.state.selectedIndentData.quotation_validity_hours), "hours")
                              ._d &&
                            this.state.selectedIndentData.quantity === this.state.selectedIndentData.confirmed_quantity
                          ) ||
                          [1].includes(vendor.pending_vendor_approval)
                        );

                      //   const negotiationHistory = this.state.negotiationsLogs
                      //   .filter(log => log.vendor_email_id === vendor.vendor_email_id)
                      //   .map(log => `${log.negotiated_value}(${log.negotiated_quantity})`)
                      //   .join(' → ');

                      // console.log(negotiationHistory,'negotiationHistory')
                      const negotiationHistory = this.state.negotiationsLogs.filter(
                        log => log.vendor_email_id === vendor.vendor_email_id
                      );

                      var vendorSob = Array.isArray(this.state.vendors_sob)
                        ? this.state.vendors_sob.find(function (sob) {
                          return (
                            sob.vendor_email &&
                            vendor.vendor_email_id &&
                            sob.vendor_email.toLowerCase() === vendor.vendor_email_id.toLowerCase()
                          );
                        })
                        : undefined;



                      return (
                        <tr key={idx} style={{ backgroundColor: "#fff" }}>
                          <td className="text-center">
                            <div className="vendor-wrapper">
                              <span
                                className="vendor-badge"
                                style={{
                                  backgroundColor:
                                    rank === "L1"
                                      ? "#28A745"
                                      : rank === "L2"
                                        ? "#FFC109"
                                        : rank === "L3"
                                          ? "#DC3545"
                                          : "#E5E5E5",
                                }}
                              >
                                {rank}
                              </span>
                              <span className="vendor-name">{vendorName}{awardedVendorEmail && isAwarded && (
                                <span className="awarded-asterisk"> *</span>
                              )}</span>
                            </div>
                          </td>
                          <td className="text-center">{vendor.transit_time || "NA"}</td>
                          {/* <td>{"★".repeat(vendor.rating || 3)}</td> */}
                          <td className='text-center'>
                             {vendorSob ? `${vendorSob.indent_awarded}(${vendorSob.sob_percentage.toFixed(2)}%)` : "0(0%)"}
                            {/* {vendorSob ? `${vendorSob.indent_awarded}` : "0(0%)"} */}
                          </td>
                          <td className="text-center">
                            <span className={`badge px-3 py-2 ${rank === "L1" ? "bg-l1" : rank === "L2" ? "bg-l2" : rank === "L3" ? "bg-l3" : "bg-lx"}`}>
                              {vendor.bid_price || "NA"}
                            </span>
                          </td>

                          {/* Editable Proposed Days */}
                          <td className="text-center">
                            <input
                              type="text"
                              className="form-control input-amount"
                              placeholder="Enter Amount"
                              value={this.state.proposedValues[vendor.vendor_email_id]}
                              onChange={(e) => {
                                const value = e.target.value;

                                if (
                                  !value ||
                                  (/^\d*$/.test(value) && value.length <= 6 && value !== "0") // Only digits, max 6 chars, not "0"
                                ) {
                                  this.setState((prevState) => ({
                                    proposedValues: {
                                      ...prevState.proposedValues,
                                      [vendor.vendor_email_id]: value
                                    }
                                  }));
                                }
                              }}

                              disabled={this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible}
                            />

                          </td>


                          {/* Editable Proposed Amount with Submit */}
                          <td className="text-center">
                            <div className="inputiconalign-wrapper">
                              <input
                                type="text"
                                className="form-control input-days"
                                placeholder="Days"
                                value={this.state.proposedDays[vendor.vendor_email_id]}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  if (
                                    !value ||
                                    (/^\d*$/.test(value) && value.length <= 6 && value !== "0") // Only digits, max 6 chars, not "0"
                                  ) {
                                    this.setState((prevState) => ({
                                      proposedDays: {
                                        ...prevState.proposedDays,
                                        [vendor.vendor_email_id]: value
                                      }
                                    }));
                                  }
                                }}
                                disabled={this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible}
                              />

                              {!(this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible) && <button
                                type="button"
                                className='btn-icon'
                                disabled={this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible}
                                onClick={() => {
                                  /* const vendorNegotiation = this.state.negotiations.find(
                                    (e) => e.vendor_email_id === vendor.vendor_email_id
                                  );
                                  const previous = vendorNegotiation ? vendorNegotiation.proposed_value : undefined;

                                  const current = this.state.inputTextValues[vendor.vendor_email_id] || previous;
                                  console.log(current, this.state.inputTextValues, "current")
                                  const vendorDays =
                                    this.state.proposedDays[vendor.vendor_email_id] !== undefined
                                      ? this.state.proposedDays[vendor.vendor_email_id]   // typed days
                                      : proposedQuantity;
                                  if (!current) {
                                    this.setState({
                                      showsweetalert: true,
                                      basicType: "danger",
                                      basicTitle: "Negotiation value cannot be empty"
                                    });
                                    return;
                                  } */

                                  // if (current === previous) {
                                  //   this.setState({
                                  //     showsweetalert: true,
                                  //     basicType: "danger",
                                  //     basicTitle: "Negotiation value cannot be the same as the previous one"
                                  //   });
                                  //   return;
                                  // }

                                  this.submitNegotiateValue(
                                    this.state.selectedIndentData.indent_id,
                                    vendor.vendor_email_id,
                                    this.state.selectedIndentData.created_by,
                                    vendor.transit_time
                                    // this.state.proposedDays[vendor.vendor_email_id]
                                  );
                                }}
                                onMouseEnter={() => this.setState({ hoveredIconId: `submit-${idx}` })}
                                onMouseLeave={() => this.setState({ hoveredIconId: null })}
                              >
                                <div className="tooltip-container">
                                  <img
                                    src={require('../../assets/images/submiticon.png')}
                                    onMouseEnter={() => this.setState({ hoveredIconId: `submit-${idx}` })}
                                    onMouseLeave={() => this.setState({ hoveredIconId: null })}
                                  />
                                  {this.state.hoveredIconId === `submit-${idx}` && (
                                    <div className="tooltip-box">
                                      Send Proposed Value
                                      <div className="tooltip-arrow-sm"></div>
                                    </div>
                                  )}
                                </div>

                              </button>}
                            </div>
                          </td>
                          <td className="text-center">{vendorValue}</td>
                          <td className="text-center">{vendorQuantity}</td>
                          <td className="indent-table-cell">
                            {negotiationHistory.length > 0 && (() => {
                              const sorted = [...negotiationHistory].sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
                              const firstTwo = sorted.slice(0, 2);
                              const remaining = sorted

                              return (
                                <div className="inline-flex-center">              {firstTwo.map((log, index) => (
                                  <span key={index} className="inlineflex-center-span">
                                    {log.negotiated_quantity} Days {parseFloat(log.negotiated_value).toLocaleString()}
                                    {index !== firstTwo.length - 1 && <span style={{ margin: '0 6px' }}>&gt;</span>}
                                  </span>
                                ))}

                                  {remaining.length > 0 && (
                                    <div
                                      className="history-ellipsis vendor-history-wrapper"
                                      onMouseEnter={() => this.setState({ hoveredHistoryIdx: vendor.vendor_email_id })}
                                      onMouseLeave={() => this.setState({ hoveredHistoryIdx: null })}
                                    >
                                      <img
                                        src={require('../../assets/images/biddingdata.png')}
                                        className="vendor-history-icon"
                                        alt="View History"
                                      />
                                      {this.state.hoveredHistoryIdx === vendor.vendor_email_id && (
                                        <div className="history-popup-textual">
                                          {(() => {
                                            const sorted = [...remaining].sort((a, b) => new Date(a.created_date) - new Date(b.created_date));
                                            const grouped = [];
                                            let i = 0;

                                            while (i < sorted.length) {
                                              const current = sorted[i];
                                              const isAdmin = current.negotiation_by === selectedIndentData.created_by;

                                              if (isAdmin) {
                                                const next = sorted[i + 1];
                                                if (next && next.negotiation_by !== selectedIndentData.created_by) {
                                                  grouped.push([current, next]);
                                                  i += 2;
                                                } else {
                                                  grouped.push([current, null]);
                                                  i += 1;
                                                }
                                              } else {
                                                grouped.push([null, current]);
                                                i += 1;
                                              }
                                            }

                                            return grouped.map(([admin, vendor], index) => (
                                              <div key={index} className="history-line-text">
                                                {admin && (
                                                  <span>{admin.negotiated_quantity} Days {parseFloat(admin.negotiated_value).toLocaleString()}</span>
                                                )}
                                                {admin && vendor && <span className="arrow"> &gt; </span>}
                                                {vendor && (
                                                  <span>{vendor.negotiated_quantity} Days {parseFloat(vendor.negotiated_value).toLocaleString()}</span>
                                                )}
                                              </div>
                                            ));
                                          })()}
                                          <div className="popup-arrow-down"></div>
                                        </div>
                                      )}
                                    </div>
                                  )}


                                </div>
                              );
                            })()}
                          </td>

                          <td className="text-center">
                            {this.state.selectedIndentData.rejected === 1 ||
                              (vendor.bid_winner == 0 &&
                                vendor.pending_vendor_approval != 1 &&
                                this.state.selectedIndentData.truck_details_completed == 1) ? (
                              <div>
                                <button
                                  type="button"
                                  className="accepted-btn-disabled"
                                  disabled
                                >
                                  Accept
                                </button>
                              </div>
                            ) : vendor.in_negotiation === 0 ? (
                              <>
                                <div className="centered-flex-gap">
                                  {/* Accepted button */}
                                  <button
                                    type="button"
                                    className="accepted-btn"
                                  >
                                    Accepted
                                  </button>

                                  {/* Truck icon (conditionally shown) */}
                                  {this.state.selectedIndentData.lr_no_completed == 1 && (
                                    <div className="tooltip-container">
                                      <button
                                        className="custom-btn label label-success"
                                        onClick={() =>
                                          this.onShowdata(this.state.selectedIndentData.indent_id)
                                        }
                                        style={{ border: "none", background: "transparent", padding: 0 }}
                                        onMouseEnter={() => this.setState({ hoveredIconId: "truck" })}
                                        onMouseLeave={() => this.setState({ hoveredIconId: null })}
                                      >
                                        <img
                                          src={require("../../assets/images/truckicon.svg")}
                                          alt="Truck"
                                          style={{ width: "20px", height: "20px" }}
                                        />
                                        {this.state.hoveredIconId === "truck" && (
                                          <div className="tooltip-box1">
                                            View Truck Details
                                            <div className="tooltip-arrow-sm1"></div>
                                          </div>
                                        )}
                                      </button>
                                    </div>

                                  )}
                                </div>
                              </>

                            ) : (new Date() >
                              moment
                                .parseZone(new Date(this.state.selectedIndentData.bid_start_date))
                                .utcOffset("-05:30")
                                .add(
                                  parseInt(this.state.selectedIndentData.quotation_validity_hours),
                                  "hours"
                                )._d &&
                              this.state.selectedIndentData.quantity ===
                              this.state.selectedIndentData.confirmed_quantity) ||
                              [1].includes(vendor.pending_vendor_approval) ? (
                              <div style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>

                                <button
                                  type="button"
                                  className="accepted-btn-disabled"
                                  disabled
                                >
                                  Accept
                                </button>
                              </div>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  disabled={disableAcceptInNegotiation}
                                  className="btn btn-success"
                                  style={{
                                    padding: "3px 15px", cursor: disableAcceptInNegotiation? "not-allowed" : "pointer", background: '#28A745'
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    const vendorNegotiation = this.state.negotiations.find(
                                      (n) => n.vendor_email_id === vendor.vendor_email_id
                                    );

                                    const vendorValue =
                                      vendorNegotiation && vendorNegotiation.vendor_value
                                        ? vendorNegotiation.vendor_value
                                        : vendor.bid_price || null;

                                    this.onClickAcceptQuotation(
                                      this.state.selectedIndentData.indent_id,
                                      vendor.bid_price,
                                      vendor.no_of_deliveries,
                                      vendor.vendor_email_id,
                                      this.state.selectedIndentData.created_by,
                                      this.state.selectedIndentData,
                                      vendorValue
                                    );
                                  }}
                                >
                                  Accept
                                </button>
                              </>
                            )}
                          </td>

                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>
            </div>

            {(this.state.selectedIndentData.indent_rejected_by_vendor === 1 ||
              this.state.selectedIndentData.vehicle_placement_expiried === 1) &&

              (
                <div style={{ textAlign: 'right', marginTop: '20px' }}>
                  <button
                    onClick={() => {
                      const confirmChange = window.confirm('Are you sure you want to change L2 as L1?');
                      if (confirmChange) {
                        this.onClickchangerankbtn(this.state.selectedIndentData);
                      }
                    }}
                    style={{
                      cursor: this.state.selectedIndentData.no_vendors === 1 ? 'not-allowed' : 'pointer',
                    }}
                    className="btn btn-primary"
                    disabled={this.state.selectedIndentData.no_vendors === 1}
                  >
                    Consider L2 as L1
                  </button>

                  <button
                    onClick={() => {
                      this.cancelindent(this.state.selectedIndentData, this.state.displayedVendorQuotes);

                    }}
                    className="btn btn-danger ml-5p"
                  >
                    Reject
                  </button>
                </div>
              )}</> : ''}
        {localStorage.getItem('user_type') == 'TRANSPORTER' ?
          <>

            <div
              className="d-flex justify-content-between align-items-center"

            >
              <h5 className="heading-18-600" >
                <span className="custom-link" onClick={() => {
                  // localStorage.removeItem("indent_id")
                  this.props.history.push("/indentsummary")
                }
                }>
                  <i className="icofont icofont-home"></i>
                </span>
                <span> / {this.state.selectedIndentData.indent_id} / Bid Details</span>
              </h5>

              {/* Back Arrow + Back Text */}
              <div className="back-btn d-flex align-items-center back-link-btn" onClick={() => {
                // localStorage.removeItem("indent_id")
                this.props.history.push("/indentsummary")
              }
              }>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M15 8a.5.5 0 0 1-.5.5H3.707l3.147 
        3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 
        0 0 1 0-.708l4-4a.5.5 0 1 1 
        .708.708L3.707 7.5H14.5A.5.5 
        0 0 1 15 8z"
                  />
                </svg>
                <span className="ml-5p">Back</span>
              </div>
            </div>
            <div>
              <div className="slider-wrapper">
                <div className="slider-section p-3">
                  <div className="info-row1">
                    <div className="label6">Indent ID </div>
                    <div>{this.state.selectedIndentData.indent_id}</div>
                  </div>
                  <div className="info-row1">
                    <div className="label6">Source </div>
                    <div>{this.state.selectedIndentData.source}</div>
                  </div>
                  <div className="info-row1">
                    <div className="label6">Destination(s) </div>
                    <div>
                      {JSON.parse(this.state.selectedIndentData.destination || "[]").map((d, i) => (
                        <span key={i} className="destination-pill">
                          {d.dealer_city.charAt(0).toUpperCase() + d.dealer_city.slice(1).toLowerCase()}
                        </span>
                      ))}
                    </div>

                  </div>
                  <div className="info-row1">
                    <div className="label6">Distance </div>
                    <div>{this.state.selectedIndentData.total_km} KM</div>
                  </div>

                  <div className="info-row1">
                    <div className="label6">Truck Type </div>
                    <div>{this.state.selectedIndentData.type_of_truck}</div>
                  </div>
                  {this.state.selectedIndentData && this.state.selectedIndentData.base_price != '' ?
                    <div className="info-row1">
                      <div className="label6">Base Price (₹)</div>
                      <div>{this.state.selectedIndentData.base_price}</div>
                    </div> : ''}
                  <div className="info-row1">
                    <div className="label6">Status </div>
                    <div className="status-badge">{this.state.selectedindentdata1.status}</div>
                  </div>

                </div>
              </div>


              <section className="section-wrapper">

                <table className="dealer-table">
                  <thead >
                    <tr className="dealer-table-header">
                      <th rowSpan="2">Bid Price (₹)</th>
                      <th rowSpan="2">Transit Days</th>

                      <th colSpan="2">Proposed</th>
                      <th colSpan="2">Vendor Value</th>
                      <th rowSpan="2">History</th>
                      <th rowSpan="2">Action</th>
                    </tr>
                    <tr className="dealer-table-header">
                      <th>Amount (₹)</th>
                      <th>Transit Days</th>
                      <th>Amount (₹)</th>
                      <th>Transit Days</th>

                    </tr>
                  </thead>
                  <tbody>
                    {indent && Array.isArray(indent.vendorquotes) && indent.vendorquotes.length > 0 ? (
                      indent.vendorquotes
                        .filter(bid => bid.vendor_email_id === localStorage.getItem('email'))
                        .map((bid, index) => {
                          const vendorNegotiation = this.state.negotiations.find(
                            e => e.vendor_email_id === bid.vendor_email_id
                          );

                          const isDisabled =
                            bid.vendor_accepted === 1 ||
                            bid.vendor_rejected === 1 ||
                            bid.vendor_accepted_negotiation === 1 ||
                            moment().isAfter(
                              moment
                                .parseZone(indent.bid_start_date)
                                .utcOffset("-05:30")
                                .add(parseInt(indent.quotation_validity_hours), "hours")
                            ) ||
                            indent.quantity === indent.confirmed_quantity ||
                            [1].includes(bid.pending_vendor_approval);

                          const proposedDaysValue =
                            vendorNegotiation && vendorNegotiation.proposed_quantity
                              ? vendorNegotiation.proposed_quantity
                              : '';

                          const proposedAmountValue =
                            vendorNegotiation && vendorNegotiation.proposed_value
                              ? vendorNegotiation.proposed_value
                              : '';

                          const previousVendorValue =
                            vendorNegotiation && vendorNegotiation.vendor_value
                              ? vendorNegotiation.vendor_value
                              : '';

                          const vendorDays = this.state.proposedDays[bid.vendor_email_id] || '';
                          const vendorAmount = this.state.inputTextValues[bid.vendor_email_id] || '';
                          const forNegotiationAfterConsiderL2AsL1 = bid.vendor_rejected !== 1 &&
                            bid.initial_negotiation == 1 &&
                            indent.rejected !== 1 &&
                            // bid.vendor_accepted !== 1 &&
                            // bid.vendor_accepted_negotiation !== 1 &&
                            bid.negotiation_closed != 1 &&
                            !(
                              new Date() >
                              moment
                                .parseZone(new Date(indent.bid_start_date))
                                .utcOffset("-05:30")
                                .add(parseInt(indent.quotation_validity_hours), "hours")
                                ._d &&
                              indent.quantity === indent.confirmed_quantity
                            ) &&
                            [1].indexOf(bid.pending_vendor_approval) === -1;
                          console.log(forNegotiationAfterConsiderL2AsL1, "forNegotiationAfterConsiderL2AsL1")
                          // negotiation window is over — either the DB flag is set or the live window has elapsed
                          const isNegotiationWindowClosed =
                            this.state.selectedIndentData.negotiation_timer_ends == 1 ||   // ✅ DB flag
                            isNegotiationExpired;                                          // ✅ Live check
                          const isAcceptButtonVisible =
                            bid.vendor_rejected !== 1 &&
                            bid.initial_negotiation == 1 &&
                            indent.rejected !== 1 &&
                            bid.vendor_accepted !== 1 &&
                            bid.vendor_accepted_negotiation !== 1 &&
                            bid.negotiation_closed != 1 &&
                            !isNegotiationWindowClosed &&
                            !(
                              new Date() >
                              moment
                                .parseZone(new Date(indent.bid_start_date))
                                .utcOffset("-05:30")
                                .add(parseInt(indent.quotation_validity_hours), "hours")
                                ._d &&
                              indent.quantity === indent.confirmed_quantity
                            ) &&
                            [1].indexOf(bid.pending_vendor_approval) === -1;
                          //      let negotiationHistory =  this.state.negotiationsLogs
                          // .filter(log => log.vendor_email_id === bid.vendor_email_id)
                          // .map(log => `${log.negotiated_value}(${log.negotiated_quantity})`)
                          // .join(' → ');
                          const negotiationHistory = this.state.negotiationsLogs.filter(
                            log => log.vendor_email_id === bid.vendor_email_id
                          );
                          return (
                            <tr key={index}>
                              {/* <td>Vendor Name</td> */}
                              <td className="text-center">
                                <span className="badge bg-success">{bid.bid_price || 'NA'}</span>
                              </td>
                              <td className="text-center">{bid.transit_time || 'NA'}</td>
                              <td className="text-center">{proposedAmountValue || '—'}</td>
                              <td className="text-center">{proposedDaysValue}</td>

                              {/* Vendor Value: Editable */}
                              <td className="text-center">
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                  <input
                                    type="text"
                                    className="form-control input-amount"
                                    placeholder="Enter Amount"
                                    style={{ width: '130px', textAlign: 'center' }}
                                    disabled={(this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible) || bid.bid_winner == 1}
                                    value={this.state.vendorValues[bid.vendor_email_id]}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (
                                        !value ||
                                        (/^\d*$/.test(value) && value.length <= 6 && value !== "0") // Only digits, max 6 chars, not "0"
                                      ) {
                                        this.setState((prevState) => ({
                                          vendorValues: {
                                            ...prevState.vendorValues,
                                            [bid.vendor_email_id]: value
                                          }
                                        }));
                                      }
                                    }}
                                  />


                                </div>
                              </td>

                              <td className="text-center">
                                <div className="centerinputicon-wrapper">
                                  <input
                                    type="text"
                                    className="form-control input-days"
                                    placeholder="Days"
                                    style={{ width: '100px', textAlign: 'center' }}
                                    disabled={(this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible) || bid.bid_winner == 1}
                                    value={this.state.vendorDays[bid.vendor_email_id]}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (
                                        !value ||
                                        (/^\d*$/.test(value) && value.length <= 6 && value !== "0") // Only digits, max 6 chars, not "0"
                                      ) {
                                        this.setState((prevState) => ({
                                          vendorDays: {
                                            ...prevState.vendorDays,
                                            [bid.vendor_email_id]: value
                                          }
                                        }));
                                      }
                                    }}
                                  />


                                  {!((this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible) || bid.bid_winner == 1) && <div
                                    className="tooltip-container relative-inline-pointer"
                                    onMouseEnter={() => this.setState({ hoveredIconId: `submit1-${index}` })}
                                    onMouseLeave={() => this.setState({ hoveredIconId: null })}
                                  >
                                    <button
                                      type="button"
                                      style={{ border: 'none', background: 'none' }}
                                      disabled={(this.state.selectedIndentData.approved_changed_l2_as_l1 == 1 ? !forNegotiationAfterConsiderL2AsL1 : !isAcceptButtonVisible) || bid.bid_winner == 1}
                                      onClick={() => {
                                        // const vendorAmount =
                                        //   this.state.inputTextValues[bid.vendor_email_id] !== undefined
                                        //     ? this.state.inputTextValues[bid.vendor_email_id]
                                        //     : vendorNegotiation && vendorNegotiation.vendor_value;

                                        // const vendorDays =
                                        //   this.state.proposedDays[bid.vendor_email_id] !== undefined
                                        //     ? this.state.proposedDays[bid.vendor_email_id]
                                        //     : vendorNegotiation && vendorNegotiation.vendor_quantity;

                                        // const previousVendorValue =
                                        //   vendorNegotiation && vendorNegotiation.vendor_value
                                        //     ? vendorNegotiation.vendor_value
                                        //     : '';
                                        // if (!vendorAmount) {
                                        //   this.setState({
                                        //     showsweetalert: true,
                                        //     basicType: 'danger',
                                        //     basicTitle: 'Negotiation value cannot be empty'
                                        //   });
                                        // }

                                        // else {
                                        this.submitNegotiateValue(
                                          indent.indent_id,
                                          bid.vendor_email_id,
                                          indent.created_by,
                                          //  vendorAmount,
                                          bid.transit_time
                                        );
                                        // }
                                      }}
                                    >
                                      <div className="tooltip-container">
                                        <img
                                          src={require("../../assets/images/submiticon.png")}
                                          onMouseEnter={() => this.setState({ hoveredIconId: `submit1-${index}` })}
                                          onMouseLeave={() => this.setState({ hoveredIconId: null })}
                                          // style={{ width: "20px", height: "20px", cursor: "pointer" }}
                                          alt="Submit"
                                        />
                                        {this.state.hoveredIconId === `submit1-${index}` && (
                                          <div className="tooltip-box">
                                            Send Vendor Value
                                            <div className="tooltip-arrow-sm"></div>
                                          </div>
                                        )}
                                      </div>


                                    </button>

                                  </div>}

                                </div>
                              </td>
                              <td className="table-cell-center-nowrap">
                                {negotiationHistory.length > 0 && (() => {
                                  const sorted = [...negotiationHistory].sort((a, b) => new Date(a.created_date) - new Date(b.created_date));
                                  const firstTwo = sorted.slice(0, 2);
                                  const remaining = sorted

                                  return (
                                    <div className="inline-flex-center-gap">
                                      {firstTwo.map((log, index) => (
                                        <span key={index} style={{ display: 'inline-flex', alignItems: 'center' }}>
                                          {log.negotiated_quantity} Days {parseFloat(log.negotiated_value).toLocaleString()}
                                          {index !== firstTwo.length - 1 && <span style={{ margin: '0 6px' }}>&gt;</span>}
                                        </span>
                                      ))}

                                      {remaining.length > 0 && (
                                        <div
                                          className="history-ellipsis"
                                          onMouseEnter={() => this.setState({ hoveredHistoryIdx: bid.vendor_email_id })}
                                          onMouseLeave={() => this.setState({ hoveredHistoryIdx: null })}
                                          style={{ position: 'relative', display: 'inline-block' }}
                                        >
                                          <img
                                            src={require('../../assets/images/biddingdata.png')}
                                            className="icon-clickable" alt="View History"
                                          />
                                          {this.state.hoveredHistoryIdx === bid.vendor_email_id && (
                                            <div className="history-popup-textual">
                                              {(() => {
                                                const sorted = [...remaining].sort((a, b) => new Date(a.created_date) - new Date(b.created_date));
                                                const grouped = [];
                                                let i = 0;

                                                while (i < sorted.length) {
                                                  const current = sorted[i];
                                                  const isAdmin = current.negotiation_by === selectedIndentData.created_by;

                                                  if (isAdmin) {
                                                    const next = sorted[i + 1];
                                                    if (next && next.negotiation_by !== selectedIndentData.created_by) {
                                                      grouped.push([current, next]);
                                                      i += 2;
                                                    } else {
                                                      grouped.push([current, null]);
                                                      i += 1;
                                                    }
                                                  } else {
                                                    grouped.push([null, current]);
                                                    i += 1;
                                                  }
                                                }

                                                return grouped.map(([admin, vendor], index) => (
                                                  <div key={index} className="history-line-text">
                                                    {admin && (
                                                      <span>{admin.negotiated_quantity} Days {parseFloat(admin.negotiated_value).toLocaleString()}</span>
                                                    )}
                                                    {admin && vendor && <span className="arrow"> &gt; </span>}
                                                    {vendor && (
                                                      <span>{vendor.negotiated_quantity} Days {parseFloat(vendor.negotiated_value).toLocaleString()}</span>
                                                    )}
                                                  </div>
                                                ));
                                              })()}
                                              <div className="popup-arrow-down"></div>
                                            </div>
                                          )}
                                        </div>
                                      )}


                                    </div>
                                  );
                                })()}
                              </td>


                              {/* Actions */}
                              {/* <td>
     <button
       type="button"
       className="btn btn-info btn-sm"
       onClick={() => {
         const negotiation = this.state.negotiations.find(
           (e) => e.vendor_email_id === bid.vendor_email_id
         );
   
         const confirmAction = window.confirm(
           `Do you want to accept the proposed value - ${negotiation && negotiation.proposed_value ? negotiation.proposed_value : '—'}?`
         );
   
         if (confirmAction && negotiation) {
           this.onClickAcceptNegotiation(
             indent.indent_id,
             negotiation.proposed_value,
             negotiation.proposed_quantity,
             bid.vendor_email_id,
             indent.created_by
           );
         }
       }}
     >
       Accept
     </button>
   </td> */}
                              <td>
                                <button
                                  type="button"
                                  className={
                                    "btn btn-" +
                                    (bid.bid_winner === 1
                                      ? "success"
                                      : bid.vendor_rejected === 1 || indent.rejected === 1
                                        ? "danger"
                                        : bid.vendor_accepted === 1 ||
                                          bid.vendor_accepted_negotiation === 1 ||
                                          indent.waiting_for_approval1 === 1 ||
                                          (new Date() > moment
                                            .parseZone(new Date(indent.bid_start_date))
                                            .utcOffset("-05:30")
                                            .add(parseInt(indent.quotation_validity_hours), "hours")._d &&
                                            indent.quantity === indent.confirmed_quantity) ||
                                          [1].includes(bid.pending_vendor_approval)
                                          ? "info"
                                          : "info")
                                  }
                                  style={{
                                    padding: "3px 26px",
                                    cursor:
                                      bid.vendor_accepted === 1 ||
                                        bid.vendor_rejected === 1 ||
                                        bid.vendor_accepted_negotiation === 1 ||
                                        isNegotiationWindowClosed ||
                                        (new Date() > moment
                                          .parseZone(new Date(indent.bid_start_date))
                                          .utcOffset("-05:30")
                                          .add(parseInt(indent.quotation_validity_hours), "hours")._d &&
                                          indent.quantity === indent.confirmed_quantity) ||
                                        [1].includes(bid.pending_vendor_approval)
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                  disabled={
                                    bid.vendor_accepted === 1 ||
                                    bid.vendor_rejected === 1 ||
                                    bid.initial_negotiation != 1 ||
                                    bid.vendor_accepted_negotiation === 1 ||
                                    isNegotiationWindowClosed ||
                                    (new Date() > moment
                                      .parseZone(new Date(indent.bid_start_date))
                                      .utcOffset("-05:30")
                                      .add(parseInt(indent.quotation_validity_hours), "hours")._d &&
                                      indent.quantity === indent.confirmed_quantity) ||
                                    [1].includes(bid.pending_vendor_approval)
                                  }
                                  onClick={() => {
                                    const isAcceptable =
                                      bid.bid_winner !== 1 &&
                                      bid.vendor_rejected !== 1 &&
                                      indent.rejected !== 1 &&
                                      bid.vendor_accepted !== 1 &&
                                      bid.vendor_accepted_negotiation !== 1 &&
                                      indent.waiting_for_approval1 !== 1 &&
                                      !isNegotiationWindowClosed &&
                                      !(
                                        new Date() >
                                        moment
                                          .parseZone(new Date(indent.bid_start_date))
                                          .utcOffset("-05:30")
                                          .add(parseInt(indent.quotation_validity_hours), "hours")._d &&
                                        indent.quantity === indent.confirmed_quantity
                                      ) &&
                                      ![1].includes(bid.pending_vendor_approval);

                                    if (isAcceptable) {
                                      const negotiation = this.state.negotiations.find(
                                        (e) => e.vendor_email_id === bid.vendor_email_id
                                      );

                                      const proposedValue = negotiation && negotiation.proposed_value ? negotiation.proposed_value : "—";

                                      this.setState({
                                        showConfirmationModal: true,
                                        proposedValue: proposedValue,
                                        confirmActionCallback: () => {
                                          if (negotiation) {
                                            this.onClickAcceptNegotiation(
                                              indent.indent_id,
                                              negotiation.proposed_value,
                                              negotiation.proposed_quantity,
                                              bid.vendor_email_id,
                                              indent.created_by
                                            );
                                          }
                                          this.closeConfirmationModal();
                                        }
                                      });
                                    }
                                  }}


                                >
                                  {
                                    bid.bid_winner === 1
                                      ? "Awarded"
                                      : bid.vendor_rejected === 1 || indent.rejected === 1
                                        ? "Rejected"
                                        : bid.vendor_accepted === 1 ||
                                          bid.vendor_accepted_negotiation === 1 ||
                                          indent.waiting_for_approval1 === 1
                                          ? "In Progress"
                                          : (new Date() > moment
                                            .parseZone(new Date(indent.bid_start_date))
                                            .utcOffset("-05:30")
                                            .add(parseInt(indent.quotation_validity_hours), "hours")._d &&
                                            indent.quantity === indent.confirmed_quantity) ||
                                            [1].includes(bid.pending_vendor_approval)
                                            ? "In Progress"
                                            : "Accept"
                                  }
                                </button>
                              </td>


                            </tr>
                          );
                        })
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">No vendor quotes available.</td>
                      </tr>
                    )}
                  </tbody>




                </table>
              </section>

              {
                indent.indent_assigned == 1 &&
                  indent.rejected != 1 &&
                  indent.indent_accepted_by_vendor != 1 &&
                  indent.vendorquotes &&
                  indent.vendorquotes.some(function (e) {
                    return (
                      e.vendor_email_id === localStorage.getItem("email") &&
                      e.indent_rejected_by_vendor !== 1 &&
                      e.bid_winner == 1
                    );
                  }) ? (
                  <div className="indentactionbtn-wrapper">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => this.acceptindentbyvendor(indent)}
                    >
                      Accept
                    </button>

                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => {
                        this.rejectindentbyvendor(indent);

                      }}
                    >
                      Reject
                    </button>
                  </div>

                ) : null
              }
              {/*  */}

            </div>


            {/* <div className="text-right px-3 py-2 border-top">
       <button className="btn btn-outline-danger mr-2" onClick={() => this.setState({ showBidDetailsSlider: false })}>
         Cancel
       </button>
       <button className="btn btn-primary">Award</button>
     </div> */}
          </> : ''}
        <div className={"slide-r " + (this.state.vehicleDetailsModel ? "slider-translate-50p" : "") +
          " slider-right"}>
          <div className="place-bid-header">
            <span>Truck Details</span>
            <button className="close-btn" onClick={this.onCloseSlider}>×</button>
          </div>

          <div className="truck-details-body">
            <div className="indent-info">
              Indent ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{this.state.selectedIndentData.indent_id}</b>
            </div>
            <div className="truck-details-table-container">
              <table className="truck-details-table">
                <thead className="table-header-blue text-white" >
                  <tr>
                    <th>S.No</th>
                    {/* <th>Indent ID</th> */}
                    <th>Dealer City</th>
                    <th>Dealer Pincode</th>
                    <th>Bid Price</th>

                    <th>Truck No</th>
                    <th>LR No/GC No</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.indent_for_approve1 && this.state.indent_for_approve1.length > 0 ? (
                    this.state.indent_for_approve1.map((destination, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        {/* <td>{destination.indent_id || "N/A"}</td> */}
                        <td>{destination.dealer_city || "N/A"}</td>
                        <td>{destination.dealer_pincode || "N/A"}</td>
                        <td>{destination.bid_price || "N/A"}</td>

                        <td>
                          <input
                            type="text"
                            placeholder="Enter Truck No"
                            value={destination.truck_no || ""}
                            readOnly
                            onChange={(e) =>
                              this.handleInputChangeforacceptfortruck(index, "truck_no", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            placeholder="Enter LR No/GC No"
                            value={destination.lr_no || ""}
                            readOnly
                            onChange={(e) =>
                              this.handleInputChangeforacceptfortruck(index, "lr_no", e.target.value)
                            }
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No destinations available</td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>

          </div>
        </div>
        {/* <Modal open={this.state.vehicleDetailsModel} styles={modalStyles1} showCloseIcon={false}>
  <div  >
    <div className="vehicle-modal-header-updated">
      <h5 className="vehicle-modal-title-updated">Vehicle Details</h5>
      <button className="close-btn-updated" onClick={this.onCloseModal}>&times;</button>
    </div>

    <div className="vehicle-modal-body-updated">
      <table className="vehicle-table-updated">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Indent ID</th>
            <th>Dealer City</th>
            <th>Dealer Pincode</th>
            <th>Bid Price</th>
            <th>Truck No</th>
            <th>LR No/GC No</th>
          </tr>
        </thead>
        <tbody>
          {this.state.indent_for_approve1.length > 0 ? (
            this.state.indent_for_approve1.map((destination, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{destination.indent_id || "N/A"}</td>
                <td>{destination.dealer_city || "N/A"}</td>
                <td>{destination.dealer_pincode || "N/A"}</td>
                                <td>{destination.bid_price || "N/A"}</td>
                <td>{destination.truck_no || "N/A"}</td>
                <td>{destination.lr_no || "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No destinations available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</Modal> */}
        {this.state.rejectModelOpen && (
          <div className="rejectmodal-overlay">
            <div className="rejectmodal-content">

              {/* Close Button Top-Right */}
              <button className="rejectmodal-close-btn" onClick={this.onCloseModal}>×</button>

              {/* Red Pin Icon */}
              <div className="rejectmodal-icon">
                <div className="rejectmodal-circle">
                  <span className="rejectmodal-cross">×</span>
                </div>
                <div className="rejectmodal-stick"></div>
              </div>

              {/* Title & Description */}
              <div className="rejectmodal-text">
                <h5>Are you sure you want to reject ?</h5>

              </div>

              {/* Textarea */}
              <div className="rejectmodal-body">
                <label>Reason: <span className="text-danger">*</span></label>
                <textarea
                  className="rejectmodal-textarea"
                  placeholder="Type the reason here..."
                  value={this.state.rejectionReasonbyapproval1}
                  onChange={(e) => this.setState({ rejectionReasonbyapproval1: e.target.value })}
                ></textarea>
              </div>

              {/* Reject Button */}
              <div className="reject-btn-container">
                <button className="text-link-reject-btn" onClick={this.onclickreject}>
                  Reject
                </button>
              </div>



            </div>
          </div>
        )}
        {this.state.showConfirmationModal && (
          <div className="reviewproposed-modal-overlay">
            <div className="reviewproposed-modal-container">

              <div className="reviewproposed-modal-header">
                <span className="reviewproposed-title">Review Proposed Value</span>
                <button className="reviewproposed-close-btn" onClick={this.closeConfirmationModal}>×</button>
              </div>

              <div className="reviewproposed-modal-body">
                <div className="reviewproposed-icon">
                  <img src={require('../../assets/icons/rupee.svg')} alt="Rupee Icon" className="reviewproposed-icon-img" />
                </div>
                <h4 className="reviewproposed-subtitle">Proposed Value</h4>
                <p className="reviewproposed-message">Do you want to accept the proposed value of</p>
                <p className="reviewproposed-value">₹ {this.state.proposedValue}</p>
              </div>

              <div className="reviewproposed-modal-footer">
                <button className="reviewproposed-reject-btn" onClick={this.closeConfirmationModal}>Cancel</button>
                <button className="reviewproposed-accept-btn" onClick={() => {
                  if (this.state.confirmActionCallback) this.state.confirmActionCallback();
                  this.closeConfirmationModal();
                }}>Accept</button>
              </div>

            </div>
          </div>
        )}

        <div className={"slide-r " + (this.state.cardforadminbifurcation ? "slider-translate-65p" : "") +
          " slider-right"}>  <div className="place-bid-header">
            {/* <span> Indent ID :&nbsp;
        {this.state.dataforadminbifur &&
        this.state.dataforadminbifur.length > 0 &&
        this.state.dataforadminbifur[0].indent_id
          ? this.state.dataforadminbifur[0].indent_id
          : "No Indent Id available"}
        &nbsp;&nbsp;&nbsp;
        Bid Price (₹):&nbsp;
        {this.state.dataforadminbifur &&
        this.state.dataforadminbifur.length > 0 &&
        this.state.dataforadminbifur[0].negotiatedconfirmed_price
          ? this.state.dataforadminbifur[0].negotiatedconfirmed_price
          : "N/A"}</span> */}
            <span>Bifurcation</span>
            <button className="close-btn" onClick={this.onCloseSlider}>×</button>
          </div>

          <div className="truck-details-body">
            <div className="indent-info">
              <div>
                Indent ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{this.state.selectedIndentData.indent_id}</b>
              </div>
              <div className="bid-price-row">
                Bid Price&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="bid-price-badge">
                  {this.state.dataforadminbifur &&
                    this.state.dataforadminbifur.length > 0 &&
                    this.state.dataforadminbifur[0].negotiatedconfirmed_price
                    ? this.state.dataforadminbifur[0].negotiatedconfirmed_price
                    : "N/A"}    </span>
              </div>
            </div>


            <div className="truck-details-table-container">

              <table className="truck-details-table">
                <thead className="table-header-blue text-white" >
                  <tr>
                    <th>S.No</th>
                    <th>Dealer Name</th>
                    <th>Dealer City</th>
                    <th>Dealer State</th>
                    <th>Dealer Pincode</th>
                    <th>Material</th>
                    <th>Bid Price (₹) <span style={{ color: "red" }}>*</span></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.dataforadminbifur.length > 0 ? (
                    this.state.dataforadminbifur.map((destination, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{destination.dealer_name || "N/A"}</td>
                        <td>{destination.dealer_city || "N/A"}</td>
                        <td>{destination.dealer_state || "N/A"}</td>
                        <td>{destination.dealer_pincode || "N/A"}</td>
                        <td>
                          {destination.materials && destination.materials.length > 0
                            ? destination.materials.map(function (mat) {
                              return mat.material_type;
                            }).join(", ")
                            : "N/A"}
                        </td>
                        <td>
                          <input
                            type="text"
                            placeholder="Enter Bid Price"
                            value={destination.bid_price || ""}
                            onChange={function (e) {
                              this.handleInputChangeforadmin_bifur(
                                index,
                                "bid_price",
                                e.target.value
                              );
                            }.bind(this)}
                            className="bid-input-field"
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">No destinations available</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className='mt-20p'>
                <label>
                  <strong>
                    Comments
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </strong>
                </label>
                <textarea
                  rows="3"
                  className="form-control accept_comment_text"
                  placeholder="Enter your comment before submitting"
                  value={this.state.adminbifurComment || ""}
                  onChange={function (e) {
                    this.setState({ adminbifurComment: e.target.value });
                  }.bind(this)}
                />
              </div>

              <div className="flex-end-gap-12">
                <button
                  className="btn-cancel-outline"
                  onClick={this.onCancel}  // Add cancel handler
                >
                  Cancel
                </button>
                <button
                  className='btn createindentbtn'
                  onClick={() => this.onSubmitdataforadminbifurcation(indent)}
                >
                  Submit
                </button>
              </div>

            </div>

          </div>
        </div>


        {this.state.cancelModelOpen && (
          <div className="rejectmodal-overlay">
            <div className="rejectmodal-content">

              {/* Close Button Top-Right */}
              <button className="rejectmodal-close-btn" onClick={this.onCloseModal}>×</button>

              {/* Red Pin Icon */}
              <div className="rejectmodal-icon">
                <div className="rejectmodal-circle">
                  <span className="rejectmodal-cross">×</span>
                </div>
                <div className="rejectmodal-stick"></div>
              </div>

              {/* Title & Description */}
              <div className="rejectmodal-text">
                <h5>Are you sure you want to reject ?</h5>
                <p>
                  Once you do this, it can’t be undone <br />
                  you won’t be able to take it back.
                </p>
              </div>

              {/* Textarea */}
              <div className="rejectmodal-body">
                <label>Tell us why you’re rejecting it: <span className="text-danger">*</span></label>
                <textarea
                  className="rejectmodal-textarea"
                  placeholder="Type the reason here..."
                  value={this.state.rejectionReasonbyvendor}
                  onChange={(e) => this.setState({ rejectionReasonbyvendor: e.target.value })}
                ></textarea>
              </div>

              {/* Reject Button */}
              <div className="reject-btn-container">
                <button className="text-link-reject-btn" onClick={this.onSubmitdataforrejection}>
                  Reject
                </button>
              </div>
            </div>
          </div>
        )}
        <div className={"dataLoadpage " + (this.state.loadshow)}>
        </div>
        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
          <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
        </div>
        <div className={"overlay " + (this.state.overlay)} onClick={this.onClickHideall}></div>

      </>
    );
  }
}

export default BidDetailsScreen;
